
<template>
  <div class="site">
     <!-- eslint-disable  -->
      <SiteHead :isNew="true" :isNews="isNews" :siteName='siteName' :regPage='regPage' :cancalChild = 'cancalChild' :thisScore='thisScore' :numScore='numScore' :isHelpShow='isHelpShow' :isChisShow='isChisShow' :helpPop="isHelp" :knowledgePop="isChis" :isShowScore='isScore' :isPy='isPy' :isLeasing='isLeasing' :goRegPage='goRegPage'></SiteHead>
      <div class="content">
        <div class="view">
          <iframe name="stie" ref="iframe" id="bdIframe" :src="view.src" frameborder="0" hight='auto'></iframe>
        </div>
      </div>
      <div class="colsPop"  v-drag v-if="AccountInfo">
        <div class="colsCont">
          <div class="close" @click="AccountInfo=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="pinyin" :class="{lv:isPingyin}" @click="lePingyin()">拼音转换</div>
          <div class="head">
            <div class="uname">账号资料</div>
            <div class="de">虚拟资料只适用模拟注册，请勿用于其它非法用途！</div>
          </div>
          <div class="cont">
            <div class="name">账号基础资料</div>
            <div class="dv"><div class="dName"><span>注册邮箱 </span><span>：</span> </div><div class="span">{{VirtualInfo.accountInfo.email}}</div> </div>
            <div class="dv"><div class="dName"><span>注册手机号</span><span>：</span></div><div class="span">{{VirtualInfo.accountInfo.phone}}</div> </div>
            <div class="dv"><div class="dName"><span>备用手机号</span><span>：</span></div><div class="span">{{VirtualInfo.accountInfo.backupPhone}}</div> </div>
            <div class="dv"><div class="dName"><span>所在地邮编</span><span>：</span></div><div class="span">{{VirtualInfo.businessInfoEntity.postCode}}</div> </div>
          </div>
          <div class="cont">
            <div class="name">信用卡资料</div>
            <div class="dv"><div class="dName"><span>信用卡持有人</span><span>：</span></div><div class="span" v-if="!isPingyin">{{VirtualInfo.accountInfo.name}}</div><div class="span" v-else>{{getPinyin(VirtualInfo.accountInfo.name)}}</div></div>
            <div class="dv"><div class="dName"><span>信用卡号</span><span>：</span></div><div class="span">{{VirtualInfo.accountInfo.cardNo}}</div> </div>
            <div class="dv"><div class="dName"><span>信用卡有效期</span><span>：</span></div><div class="span" >{{VirtualInfo.accountInfo.cardValidity}}</div> </div>
            <div class="dv"><div class="dName"><span>信用卡账单地址</span><span>：</span></div><div class="span" v-if="!isPingyin">{{VirtualInfo.accountAddress.cardFullAddress}}</div><div class="span" v-else >{{getPinyin(VirtualInfo.accountAddress.cardFullAddress)}}</div>  </div>
            <div class="dv"><div class="dName"><span>信用卡账单国家</span><span>：</span></div><div class="span"  v-if="!isPingyin">{{VirtualInfo.accountAddress.cardCountry}}</div><div class="span" v-else>China</div></div>
            <div class="dv"><div class="dName"><span>信用卡账单邮编</span><span>：</span></div><div class="span">{{VirtualInfo.accountAddress.cardPostCode}}</div></div>
          </div>
          <div class="cont">
            <div class="name">收款账户资料</div>
            <div class="dv"><div class="dName"><span>金融机构名称</span><span>：</span></div><div class="span">Lianlian Pay</div> </div>
            <div class="dv"><div class="dName"><span>收款账户所在国家</span><span>：</span></div><div class="span">美国</div> </div>
            <div class="dv"><div class="dName"><span>账户持有人姓名</span><span>：</span></div><div class="span">{{VirtualInfo.accountInfo.accountHoldName}}</div></div>
            <div class="dv"><div class="dName"><span>9位数的银行识别代码</span><span>：</span></div><div class="span">{{VirtualInfo.accountInfo.routingNumber}}</div></div>
            <div class="dv"><div class="dName"><span>银行账号</span><span>：</span></div><div class="span">{{VirtualInfo.accountInfo.accountNumber}}</div></div>
          </div>
        </div>
      </div>
      <div class="colsPop"  v-drag v-if="isIds">
        <div class="colsCont">
          <div class="close" @click="isIds=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="head">
            <div class="uname">法人身份证</div>
            <div class="de">虚拟资料只适用模拟注册，请勿用于其它非法用途！</div>
          </div>
          <div class="cont">
            <div class="name">身份证正面 <div class="btn" @click="downloadCodeImg(0)">下载</div></div>
            <div class="ids">
              <img :src="VirtualInfo.virtualPicPre+'/'+VirtualInfo.num+'/身份证正面.jpg'" alt="">
            </div>
          </div>
           <div class="cont">
            <div class="name">身份证反面 <div class="btn" @click="downloadCodeImg(1)">下载</div></div>
            <div class="ids">
              <img :src="VirtualInfo.virtualPicPre+'/'+VirtualInfo.num+'/身份证背面.jpg'" alt="">
            </div>
          </div>
        </div>
      </div>
       <div class="colsPop pyPop"  v-drag v-if="isPy">
        <div class="colsCont">
          <div class="close" @click="isPy=false;zwCont='';pingyinCont='';">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="head">
            <div class="uname">汉字转拼音</div>
          </div>
          <div class="input_wrap">
            <div class="ipt">
              <label >中文</label><input type="text" v-model="zwCont">
            </div>
            <div class="ipt">
              <label >拼音</label> <input type="text" v-model="pingyinCont">
            </div>
          </div>
          <div class="iBtn" @click="goPinyin">一键转换</div>
        </div>
      </div>
      <div class="colsPop"  v-drag v-if="businessLicense">
        <div class="colsCont">
          <div class="close" @click="businessLicense=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="head">
            <div class="uname">营业执照</div>
            <div class="de">虚拟资料只适用模拟注册，请勿用于其它非法用途！</div>
          </div>
          <div class="cont" >
            <div class="name">营业执照<div class="btn" @click="downloadCodeImg(2)">下载</div></div>
            <div class="ids">
              <img :src="VirtualInfo.virtualPicPre+'/'+VirtualInfo.num+'/营业执照正本.jpg'" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="pop_bg" v-if="reexamination"></div>
      <CommonPop :reexamination='reexamination' :scoreFun ='scoreFun' :textCommonPop='textCommonPop' ></CommonPop>
      <div class="tipsPop" v-if="tips">
      <div class="head">
          提示
          <div class="icon" @click="tips=false">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="co">
            <img src="../../assets/images/mark.png" alt="">
          </div>
          <div class="cont">
              您将要清空所有注册数据，确认是否继续
          </div>   
          <div class="btnWrap">
              <div class="btn" @click="deleteInfo()">是</div><div class="btnN" @click="tips=false">否</div>
          </div>
      </div>
    </div>
    <div class="pop_bg" v-if="isSelectPop"></div>
    <div class="selectPop" v-if="isSelectPop">
      <div class="title">
        恭喜您，已完成模拟注册 
          <div class="close" @click="isSelectPop=false">
              <img src="../../assets/images/close.svg" >
          </div>
        </div>
      <div class="btn" @click="cancalChild('score')">
        查看填写参考
      </div>
    </div>
      <div class="pop_bg" v-if="isScore"></div>
      <div class="scorePop" v-if="isScore">
          <div class="head">
              <!-- <div class="el">
                  <div class="li avt">
                     <div class="num">{{thisScore}}</div> 
                     <div class="nx">目前得分</div>
                  </div>
                  <div class="li">
                     <div class="num">{{numScore}}</div> 
                     <div class="nx">目前总分</div>
                  </div>
              </div> -->
              <!-- <div class="ps">考核分数只是针对注册中的填写信息对错来衡量，不与实际注册成功与否挂钩！！！</div> -->
              <div class="btnScore" @click="tips=true">重新练习</div>
              <div class="close" @click="closeScore">
                <img src="../../assets/images/close.svg" >
              </div>
          </div>
          <div class="cont">
            <div class="titUl">
              <div class="li">注册信息</div>
              <div class="li fx4">填写内容</div>
              <!-- <div class="li">评分</div> -->
              <div class="li">结果</div>
              <div class="li fx4">填写信息知识点说明</div>
            </div>
            <div class="conList">
               <div class="titUl" v-for="(item,index) in infoScore" :key="index" :class="{avt:item.result==0}">
                <div class="li">{{item.name}}</div>
                <div class="li fx4">{{item.mcont}}</div>
                <!-- <div class="li">{{item.credit}}</div> -->
                <div class="li dP"><img :src="item.result==0?require('../../assets/images/Wrong.png'):require('../../assets/images/correct.png')" alt="">{{item.resultCont}}</div>
                <div class="li fx4">{{item.knowledgePoint}}</div>
              </div>
            </div>
          </div>
      </div>
    
  </div>
</template>
<script>
import SiteHead from '../../components/SiteHead/Index';
import CommonPop from '../../components/CommonPop/Index';
export default {
  name: "site",
  data: function() {
    return {
      siteName:sessionStorage.site,
      regPage:[
        '登录账号',
        '创建账户',
        '验证电子邮箱',
        '添加手机号码',
        '注册前信息',
        '公司信息',
        '个人信息',
        '付款信息说明',
        '收款账户信息',
        '验证提示',
        '信用卡信息',
        '店铺信息页',
        '身份文件验证页',
        '视频通话验证',
        '视频通话时间预约',
        '视频通话预约确认',
        '加入视频通话',
        '地址验证',
        '开启卖家账户销售',
        '设置两步验证页',
        '登录账号页',
        '获取链接页',
        '登录确认页',
        '注册两步验证认证器页',
        '两步验证完成页',
        '注册成功页',
        '提交税务信息页（一）',
        '提交税务信息页（二）',
        '提交税务信息页（三）',
        '卖家后台页',
        '存款方式（一）',
        '存款方式（二）',
        '存款方式（三）',
        '卖家后台页',
        '考核报表',
        ],
       isNews:true, 
      numScore:0,
      thisScore:0,
      zwCont:'',
      isLeasing:'',
      pingyinCont:'',
      isPingyin:false,
      isSelectPop:false,
      numScores:null,
      textCommonPop:'',
      infoScore:[],
      reexamination:false,
      isHelpShow:false,
      isScore:false,
      isPy:false,
      isChisShow:false,
      iframeHeight:null,
      isHelp:false,
      isChis:false,
      AccountInfo:false,
      isIds:false,
      VirtualInfo:{},
      businessLicense:false,
      iframeWin: {},
      tips:false,
      mPage:'',
      view:{
         src:'',
      },
      regInfo:{
        creditRuleEntityList:[{"correctShow":"符合要求","credit":"8","errorShow":"不符合要求","knowledgePoint":"拼音填写法人代表人姓名","page":"1","regInfo":"名字"},{"correctShow":"填写正确","credit":"8","errorShow":"填写错误","knowledgePoint":"填写能收到的注册链接的邮箱","page":"1","regInfo":"邮箱"},{"correctShow":"选择正确","credit":"1","errorShow":"选择错误","knowledgePoint":"选择注册手机号码区号","page":"2","regInfo":"区号"},{"correctShow":"填写正确","credit":"4","errorShow":"填写错误","knowledgePoint":"输入未注册过亚马逊的手机号","page":"2","regInfo":"手机号码"},{"correctShow":"选择正确","credit":"1","errorShow":"选择错误","knowledgePoint":"选择营业执照中地址的所在国家","page":"3","regInfo":"公司地址-国家/地区"},{"correctShow":"选择正确","credit":"1","errorShow":"选择错误","knowledgePoint":"选择公司业务类型","page":"3","regInfo":"业务类型"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"英文填写公司法定名称","page":"3","regInfo":"企业名称-英文"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"中文填写公司法定名称","page":"3","regInfo":"企业名称-中文"},{"correctShow":"填写正确","credit":"5","errorShow":"填写错误","knowledgePoint":"填写营业执照上的统一社会代码","page":"4","regInfo":"公司注册号码"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"填写公司所在地区邮编","page":"4","regInfo":"经营地址-邮编"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"中文填写公司所在的省份","page":"4","regInfo":"经营地址-省份"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"中文填写公司所在的城市","page":"4","regInfo":"经营地址-城市"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"中文填写公司所在的区域","page":"4","regInfo":"经营地址-区域"},{"correctShow":"符合要求","credit":"2","errorShow":"不符合要求","knowledgePoint":"中文填写公司的街道地址","page":"4","regInfo":"经营地址-街道地址"},{"correctShow":"符合要求","credit":"2","errorShow":"不符合要求","knowledgePoint":"中文填写公司的详细地址","page":"4","regInfo":"经营地址-详情地址"},{"correctShow":"填写正确","credit":"3","errorShow":"填写错误","knowledgePoint":"填写未在亚马逊使用过的手机号","page":"4","regInfo":"验证的电话号码"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"拼音填写法人名字","page":"4","regInfo":"主要联系人-名字"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"拼音填写法人姓氏","page":"4","regInfo":"主要联系人-姓氏"},{"correctShow":"选择正确","credit":"2","errorShow":"选择错误","knowledgePoint":"选择法人所在的国籍","page":"5","regInfo":"个人信息-国籍"},{"correctShow":"选择正确","credit":"2","errorShow":"选择错误","knowledgePoint":"选择法人出生地","page":"5","regInfo":"个人信息-出生地"},{"correctShow":"选择正确","credit":"2","errorShow":"选择错误","knowledgePoint":"选择法人出生日期","page":"5","regInfo":"个人信息-出生日期"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"填写法人身份证号码","page":"5","regInfo":"个人信息-身份证号码"},{"correctShow":"选择正确","credit":"2","errorShow":"选择错误","knowledgePoint":"填写法人身份证号码有效期","page":"5","regInfo":"个人信息-有效期"},{"correctShow":"选择正确","credit":"2","errorShow":"选择错误","knowledgePoint":"选择法人身份证签发国","page":"5","regInfo":"个人信息-签发国"},{"correctShow":"填写正确","credit":"1","errorShow":"填写错误","knowledgePoint":"中文填写法人姓氏","page":"5","regInfo":"个人信息-姓氏"},{"correctShow":"填写正确","credit":"1","errorShow":"填写错误","knowledgePoint":"中文填写法人名字","page":"5","regInfo":"个人信息-名字"},{"correctShow":"填写正确","credit":"1","errorShow":"填写错误","knowledgePoint":"填写个人实际居住地址邮编","page":"5","regInfo":"居住地址-邮编"},{"correctShow":"填写正确","credit":"1","errorShow":"填写错误","knowledgePoint":"中文填写个人实际居住地址省份","page":"5","regInfo":"居住地址-省份"},{"correctShow":"填写正确","credit":"1","errorShow":"填写错误","knowledgePoint":"中文填写个人实际居住地址城市","page":"5","regInfo":"居住地址-城市"},{"correctShow":"填写正确","credit":"1","errorShow":"填写错误","knowledgePoint":"中文填写个人实际居住地址区域","page":"5","regInfo":"居住地址-区域"},{"correctShow":"符合要求","credit":"1","errorShow":"不符合要求","knowledgePoint":"中文填写个人实际居住详细地址1","page":"5","regInfo":"居住地址-地址行1"},{"correctShow":"符合要求","credit":"1","errorShow":"不符合要求","knowledgePoint":"中文填写个人实际居住详细地址2","page":"5","regInfo":"居住地址-地址行2"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"填写法人手机号","page":"5","regInfo":"手机号码"},{"correctShow":"选择正确","credit":"1","errorShow":"未选择","knowledgePoint":"勾选个人权利","page":"5","regInfo":"收益所有人"},{"correctShow":"选择正确","credit":"1","errorShow":"未选择","knowledgePoint":"勾选个人权利","page":"5","regInfo":"法人代表"},{"correctShow":"选择正确","credit":"1","errorShow":"选择错误","knowledgePoint":"确认受益人人数","page":"5","regInfo":"添加受益人"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"填写可以国际付款的信用卡(VISA,Master卡均可，推荐VISA)","page":"6","regInfo":"账单信息-信用卡号"},{"correctShow":"选择正确","credit":"2","errorShow":"选择错误","knowledgePoint":"选择信用卡有效期","page":"6","regInfo":"账单信息-有效期"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"拼音填写信用卡持卡人姓名","page":"6","regInfo":"账单信息-持卡人姓名"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"填写信用卡账单地址邮编","page":"6","regInfo":"账单地址-邮编"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"中文填写信用卡账单地址省份","page":"6","regInfo":"账单地址-省份"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"中文填写信用卡账单地址城市","page":"6","regInfo":"账单地址-城市"},{"correctShow":"填写正确","credit":"2","errorShow":"填写错误","knowledgePoint":"中文填写信用卡账单地址区域","page":"6","regInfo":"账单地址-区域"},{"correctShow":"符合要求","credit":"2","errorShow":"不符合要求","knowledgePoint":"中文填写信用卡账单街道地址","page":"6","regInfo":"账单地址-街道地址"},{"correctShow":"符合要求","credit":"1","errorShow":"不符合要求","knowledgePoint":"中文填写信用卡账单详细地址2","page":"6","regInfo":"账单地址-地址行2"},{"correctShow":"填写正确","credit":"1","errorShow":"填写错误","knowledgePoint":"英文填写店铺名称，自行设置","page":"7","regInfo":"店铺名称"},{"correctShow":"上传正确","credit":"2","errorShow":"上传错误","knowledgePoint":"上传法人身份证正面照片（国徽面）","page":"8","regInfo":"身份证正面"},{"correctShow":"上传正确","credit":"2","errorShow":"上传错误","knowledgePoint":"上传法人身份证反面照片（姓名面）","page":"8","regInfo":"身份证反面"},{"correctShow":"上传正确","credit":"2","errorShow":"上传错误","knowledgePoint":"上传法人营业执照照片","page":"8","regInfo":"营业执照"},{"credit":"100"}]
      },
      AmazonRegAccountInfo:{},
      chis:'0',
      help:'0',
      VideoNum:null
    };
  },
 //注册局部组件指令
  directives: {
      drag: function(el) {
          let dragDiv = el; //获取当前元素
          dragDiv.addEventListener("mousedown", function(e) {
             if(e.target.className=='de' || e.target.className== 'uname'){
              //获取div初始位置对象
              var divRect = dragDiv.getBoundingClientRect();
              //获取鼠标点击的位置
              var downX = e.clientX;
              var downY = e.clientY;
              //开关打开
              var startMove = true;
              //设置样式为移动光标
              dragDiv.style.cursor = "move";
              window.onmousemove = function(e) {
              if (!startMove) {
              return;
              }
              let newLeft = e.clientX - downX + divRect.left;
              let newTop = e.clientY - downY + divRect.top;
              if(newLeft>=0){
                dragDiv.style.left = newLeft + "px";
              }
              if(newTop>=0){
                dragDiv.style.top = newTop + "px";
              }
              return false;
              };
              window.onmouseup = function(e) {
              //结束移动
              startMove = false;
              dragDiv.style.cursor = "default";
              return false;
              };

              e.stopPropagation();
             }
        });
      }
  },
  mounted () {
    /* eslint-disable */
    let oIframe = document.getElementById('bdIframe');
    let regInfoJson={};
      // 在外部vue的window上添加postMessage的监听，并且绑定处理函数handleMessage
      window.addEventListener('message', event => {
            // 根据上面制定的结构来解析iframe内部发回来的数据
          const data = event.data
          console.log(data)
          try { 
            if(data){
              if(data=='deleteInfo'){
                this.deleteInfo('ifemDe')
              }
              if(data=='creditok'){
                if(sessionStorage.getItem('zsMode')!=9){
                   this.isSelectPop=true;
                }
              }
              regInfoJson=this.regInfo.virtualConfigEntityList.filter(item => item.currentPage==data.mPage)
             if(data.iframeHeight){
               this.isChisShow=false;
               this.isHelpShow=false;
               this.help='0'
               this.chis='0'
                this.getScoreList()
              }
              if(data.mPage){
                this.mPage=data.mPage
                this.VideoNum= parseInt(data.mPage.substring(1).substring(1).substring(1));
              }
              
              if(data.chis==0){
                this.isChisShow=false;
              }
              if(data.help==0){
                  this.isHelpShow=false;
              }
              if(regInfoJson[0].helpBtn==0){
                  this.isHelp=false;
                }else{
                  this.isHelp=true;
                }
              if(regInfoJson[0].knowledgeBtn==0){
                this.isChis=false;
              }else{
                this.isChis=true;
              }
            }
            
        } catch(err) {
        }
          
        });
      this.iframeWin = this.$refs.iframe.contentWindow;
    },
    computed: {
        user() {
          return this.$store.getters.user;
        },
  },
   watch: {
  },
  created(){
    if(!sessionStorage.site){
      location.href=this.interfaceJson.localUrl+'VirtualReg'
    }
    // sessionStorage.multilingual='0'
    // this.getSite()
    this.getStieJSON()
    this.getStieHelp()
    this.getVirtualInfo()
    this.getBeforeAmazonRegAccountInfo()
  },
  methods: {
    getStieHelp(){
        this.$axios
			. get(this.interfaceJson.ipUrl+'/credit-rule/self_help_config.json')
        .then(res => {
          if(res.data){
            this.regInfo.virtualConfigEntityList=res.data
             sessionStorage.setItem('regInfo',JSON.stringify(this.regInfo))
            if(this.regInfo.virtualConfigEntityList[1].helpBtn==0){
              this.isHelp=false;
            }else{
              this.isHelp=true;
            }
             if(this.regInfo.virtualConfigEntityList[1].knowledgeBtn==0){
              this.isChis=false;
            }else{
              this.isChis=true;
            }
          }
      });
      },
    getStieJSON(){
        this.$axios
			. get(this.interfaceJson.ipUrl+'/credit-rule/us_new_v2.json')
        .then(res => {
          if(res.data){
            this.regInfo.creditRuleEntityList=res.data
          }
      });
      },
      goRegPage(e){
          switch (e) {
            case 0:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/Sellerlogin_us.html'
              break;
            case 1:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg1_us.html'
              break;
            case 2:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg2_us.html'
                break;
            case 3:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg3_us.html'
                break;
            case 4:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg4_us.html'
                break;
            case 5:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg5_us.html'
                break;
            case 6:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg6_us.html'
                break; 
            case 7:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg7_us.html'
                break; 
            case 8:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg8_us.html'
                break; 
            case 9:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg9_us.html'
                break; 
            case 10:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg10_us.html'
              break;
            case 11:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg11_us.html'
                break; 
            case 12:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg12_us.html'
                break; 
            case 13:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg13_us.html'
              break;
            case 14:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg14_us.html'
                break; 
            case 15:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg15_us.html'
                break; 
            case 16:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg16_us.html'
              break;  
            case 17:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg17_us.html'
                break; 
            case 18:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg18_us.html'
                break; 
            case 19:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg19_us.html'
              break;
            case 20:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg20_us.html'
                break; 
            case 21:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg21_us.html'
                break; 
            case 22:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg22_us.html'
              break;
            case 23:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg23_us.html'
                break; 
            case 24:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg24_us.html'
                break; 
            case 25:
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/UScn.html'
              sessionStorage.tax_signature =''
              sessionStorage.ckAccountNumber=''
              break;    
            case 26:
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/tax1.html'
                 sessionStorage.tax_signature='111'
              break;
            case 27:
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/tax2.html'
              break;
            case 28:
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/tax3.html'
              break; 
            case 29:
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/UScn.html'
              break;  
            case 30:
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/CK1cn.html'
              break;
            case 31:
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/CK2cn.html'
                sessionStorage.ckAccountNumber='111'
              break;
            case 32:
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/CK3cn.html'
              break; 
            case 33:
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/UScn.html'
              break;                      
            case 34:
              this.getManager(this.mPage)
              this.isScore=true;
              this.isSelectPop=false;
              break;       
            // case 12:
            //   window.open(this.interfaceJson.ipUrl+'/admin/sellercentral.html') 
            //   break;  
         }
      },
      goPinyin(){
        if(this.zwCont){
          this.pingyinCont= this.getPinyin(this.zwCont).trim()
        }
      },
      lePingyin(){
        this.isPingyin=!this.isPingyin;
      },
      deleteInfo(e){
          this.$axios
          .post(this.interfaceJson.serverAddress+"/api/site/amazonRegAccountInfoDelete","NEW_SELLER_"+sessionStorage.site)
          .then(res => {
          let data=res.data;
          if(data.code==0){
            this.reexamination=false
            this.AmazonRegAccountInfo={};
            this.infoScore=[];
            this.isScore=false;
            this.tips=false;
            sessionStorage.creditMarket = 0
            sessionStorage.removeItem('pageArr');
            sessionStorage.removeItem('ckCountry');
            sessionStorage.removeItem('seCountry');
            sessionStorage.removeItem('ckAccountNumber');
            sessionStorage.removeItem('ckAccountHolderName');
            sessionStorage.removeItem('ckRoutingNumber');
            sessionStorage.removeItem('ckAccountNumberReEnter');
            sessionStorage.removeItem('tax_ogname');
            sessionStorage.removeItem('m_og_name');
            sessionStorage.removeItem('tax_ogcountry');
            sessionStorage.removeItem('m_og_country');
            sessionStorage.removeItem('tax_disregard');
            sessionStorage.removeItem('m_Disregarded_name');
            sessionStorage.removeItem('tax_addr1');
            sessionStorage.removeItem('m_tax_addr_1');
            sessionStorage.removeItem('tax_city1');
            sessionStorage.removeItem('m_tax_city');
            sessionStorage.removeItem('tax_addr2');
            sessionStorage.removeItem('m_tax_addr_2');
            sessionStorage.removeItem('m_isUSA');
            sessionStorage.removeItem('m_taxtype');
            sessionStorage.removeItem('m_benType');
            sessionStorage.removeItem('m_Permanent_country');
            sessionStorage.removeItem('m_tax_state');
            sessionStorage.removeItem('m_taxzipcode');
            sessionStorage.removeItem('m_Signature');
            sessionStorage.removeItem('tax_signature');
            sessionStorage.removeItem('m_tax_Date');
            sessionStorage.removeItem('tax_date');
            // if(e!='ifemDe'){
             location.reload()
            // }
          }else{
            
          }
          });
      },
      calcs(arr){
       return arr.reduce((result, nextObj, i) => {
           return result + nextObj
       });
     },
      scoreFun(e){
      // 继续操作
        if(e=='1'){
           if(this.AmazonRegAccountInfo.step==25){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/UScn.html'
          }else{
            this.goStep()
          }
          this.reexamination=false
        }
        if(e=='0'){
          if(this.user.zs==9){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg1_us.html'
          }else{
            this.deleteInfo()
          }
        }
      },
      closeScore(){
        this.infoScore=[];
        this.isScore=false;
      },
     // 卖家1号评分数据
      getManager(mPage){
        this.infoScore=[];
        this.thisScore=0;
        this.numScore=0;
          // reg1
        if(mPage=='reg2_newus'||mPage=='reg3_newus'||mPage=='reg4_newus'||mPage=='reg5_newus'||mPage=='reg6_newus'||mPage=='reg7_newus'||mPage=='reg8_newus'||mPage=='reg9_newus'||mPage=='reg10_newus'||mPage=='reg11_newus'||mPage=='reg12_newus'||mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+(this.regInfo.creditRuleEntityList[0].credit+this.regInfo.creditRuleEntityList[1].credit);
            this.numScore= this.numScore +(this.regInfo.creditRuleEntityList[0].credit+this.regInfo.creditRuleEntityList[1].credit);
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[0].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.accountInfo.name),
                credit:this.regInfo.creditRuleEntityList[0].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[0].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[0].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[1].regInfo,
                mcont:this.VirtualInfo.accountInfo.email,
                credit:this.regInfo.creditRuleEntityList[1].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[1].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[1].knowledgePoint
            })
        }
        // reg3
        if(mPage=='reg4_newus'||mPage=='reg5_newus'||mPage=='reg6_newus'||mPage=='reg7_newus'||mPage=='reg8_newus'||mPage=='reg9_newus'||mPage=='reg10_newus'||mPage=='reg11_newus'||mPage=='reg12_newus'||mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.numScore= this.numScore +(this.regInfo.creditRuleEntityList[2].credit+this.regInfo.creditRuleEntityList[3].credit);
             this.thisScore=this.numScore;                           
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[3].regInfo,
                mcont:this.VirtualInfo.accountInfo.phone,
                credit:this.regInfo.creditRuleEntityList[3].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[3].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[2].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[2].regInfo,
                mcont:'+86',
                credit:this.regInfo.creditRuleEntityList[2].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[2].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[2].knowledgePoint
            })
        }
         // reg4
        if(mPage=='reg5_newus'||mPage=='reg6_newus'||mPage=='reg7_newus'||mPage=='reg8_newus'||mPage=='reg9_newus'||mPage=='reg10_newus'||mPage=='reg11_newus'||mPage=='reg12_newus'||mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+(this.regInfo.creditRuleEntityList[7].credit
            +this.regInfo.creditRuleEntityList[4].credit
            +this.regInfo.creditRuleEntityList[5].credit
            +this.regInfo.creditRuleEntityList[6].credit
            );
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[4].regInfo,
                mcont:'China',
                credit:this.regInfo.creditRuleEntityList[4].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[4].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[4].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[5].regInfo,
                mcont:'Privately-owned business',
                credit:this.regInfo.creditRuleEntityList[5].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[5].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[5].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[6].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.name),
                credit:this.regInfo.creditRuleEntityList[6].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[6].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[6].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[7].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.name,
                credit:this.regInfo.creditRuleEntityList[7].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[7].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[7].knowledgePoint
            },)
        }
        // reg5
         if(mPage=='reg6_newus'||mPage=='reg7_newus'||mPage=='reg8_newus'||mPage=='reg9_newus'||mPage=='reg10_newus'||mPage=='reg11_newus'||mPage=='reg12_newus'||mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+(
            +this.regInfo.creditRuleEntityList[17].credit
            +this.regInfo.creditRuleEntityList[8].credit
            +this.regInfo.creditRuleEntityList[9].credit
            +this.regInfo.creditRuleEntityList[10].credit
            +this.regInfo.creditRuleEntityList[11].credit
            +this.regInfo.creditRuleEntityList[12].credit
            +this.regInfo.creditRuleEntityList[13].credit
            +this.regInfo.creditRuleEntityList[14].credit
            +this.regInfo.creditRuleEntityList[15].credit
            +this.regInfo.creditRuleEntityList[16].credit
            );
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[8].regInfo,
                mcont: this.VirtualInfo.businessInfoEntity.societyCode,
                credit:this.regInfo.creditRuleEntityList[8].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[8].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[8].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[9].regInfo,
                mcont: this.VirtualInfo.businessInfoEntity.postCode,
                credit:this.regInfo.creditRuleEntityList[9].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[9].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[9].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[10].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.state,
                credit:this.regInfo.creditRuleEntityList[10].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[10].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[10].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[11].regInfo,
                mcont: this.VirtualInfo.businessInfoEntity.city,
                credit:this.regInfo.creditRuleEntityList[11].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[11].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[11].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[12].regInfo,
                mcont: this.VirtualInfo.businessInfoEntity.city,
                credit:this.regInfo.creditRuleEntityList[12].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[12].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[12].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[13].regInfo,
                mcont: this.VirtualInfo.businessInfoEntity.addressOne,
                credit:this.regInfo.creditRuleEntityList[13].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[13].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[13].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[14].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.addressTwo,
                credit:this.regInfo.creditRuleEntityList[14].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[14].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[14].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[15].regInfo,
                mcont:this.VirtualInfo.accountInfo.phone,
                credit:this.regInfo.creditRuleEntityList[15].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[15].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[15].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[16].regInfo,
                mcont: this.getMing(this.VirtualInfo.accountInfo.name),
                credit:this.regInfo.creditRuleEntityList[16].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[16].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[16].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[17].regInfo,
                mcont:this.getXing(this.VirtualInfo.accountInfo.name),
                credit:this.regInfo.creditRuleEntityList[17].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[17].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[17].knowledgePoint
            })
        }
         // reg6
         if(mPage=='reg7_newus'||mPage=='reg8_newus'||mPage=='reg9_newus'||mPage=='reg10_newus'||mPage=='reg11_newus'||mPage=='reg12_newus'||mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+(this.regInfo.creditRuleEntityList[34].credit
                                           +this.regInfo.creditRuleEntityList[18].credit
                                           +this.regInfo.creditRuleEntityList[19].credit
                                           +this.regInfo.creditRuleEntityList[20].credit
                                           +this.regInfo.creditRuleEntityList[21].credit
                                           +this.regInfo.creditRuleEntityList[22].credit
                                           +this.regInfo.creditRuleEntityList[23].credit
                                           +this.regInfo.creditRuleEntityList[24].credit
                                           +this.regInfo.creditRuleEntityList[25].credit
                                           +this.regInfo.creditRuleEntityList[26].credit
                                           +this.regInfo.creditRuleEntityList[27].credit
                                           +this.regInfo.creditRuleEntityList[28].credit
                                           +this.regInfo.creditRuleEntityList[29].credit
                                           +this.regInfo.creditRuleEntityList[30].credit
                                           +this.regInfo.creditRuleEntityList[31].credit
                                           +this.regInfo.creditRuleEntityList[32].credit
                                           +this.regInfo.creditRuleEntityList[33].credit
                                           +this.regInfo.creditRuleEntityList[35].credit);
            this.numScore= this.thisScore
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[18].regInfo,
                mcont:'China',
                credit:this.regInfo.creditRuleEntityList[18].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[18].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[18].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[19].regInfo,
                mcont:'China',
                credit:this.regInfo.creditRuleEntityList[19].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[19].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[19].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[20].regInfo,
                mcont:this.VirtualInfo.accountInfo.birthday,
                credit:this.regInfo.creditRuleEntityList[20].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[20].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[20].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[21].regInfo,
                mcont:this.VirtualInfo.accountInfo.idNum,
                credit:this.regInfo.creditRuleEntityList[21].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[21].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[21].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[22].regInfo,
                mcont:this.VirtualInfo.accountInfo.idValidity,
                credit:this.regInfo.creditRuleEntityList[22].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[22].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[22].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[23].regInfo,
                mcont:'CN',
                credit:this.regInfo.creditRuleEntityList[23].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[23].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[23].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[24].regInfo,
                mcont:this.VirtualInfo.accountInfo.name.substring(0,1),
                credit:this.regInfo.creditRuleEntityList[24].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[24].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[24].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[25].regInfo,
                mcont:this.VirtualInfo.accountInfo.name.substring(1,2),
                credit:this.regInfo.creditRuleEntityList[25].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[25].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[25].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[26].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.postCode,
                credit:this.regInfo.creditRuleEntityList[26].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[26].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[26].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[27].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.state,
                credit:this.regInfo.creditRuleEntityList[27].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[27].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[27].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[28].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.city,
                credit:this.regInfo.creditRuleEntityList[28].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[28].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[28].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[29].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.addressTwo,
                credit:this.regInfo.creditRuleEntityList[29].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[29].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[29].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[30].regInfo,
                mcont: this.VirtualInfo.businessInfoEntity.addressOne,
                credit:this.regInfo.creditRuleEntityList[30].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[30].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[30].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[31].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.addressTwo,
                credit:this.regInfo.creditRuleEntityList[31].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[31].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[31].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[32].regInfo,
                mcont: this.VirtualInfo.accountInfo.phone,
                credit:this.regInfo.creditRuleEntityList[32].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[32].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[32].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[33].regInfo,
                mcont: '收益所有人',
                credit:this.regInfo.creditRuleEntityList[33].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[33].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[33].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[34].regInfo,
                mcont:'法定代表人',
                credit:this.regInfo.creditRuleEntityList[34].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[34].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[34].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[35].regInfo,
                mcont: '已添加受益人',
                credit:this.regInfo.creditRuleEntityList[35].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[35].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[35].knowledgePoint
            })
        }  

        // reg8
        if(mPage=='reg9_newus'||mPage=='reg10_newus'||mPage=='reg11_newus'||mPage=='reg12_newus'||mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
           this.thisScore= this.thisScore+(
                            this.regInfo.creditRuleEntityList[36].credit
                            +this.regInfo.creditRuleEntityList[37].credit
                            +this.regInfo.creditRuleEntityList[38].credit
                            +this.regInfo.creditRuleEntityList[39].credit
                            +this.regInfo.creditRuleEntityList[40].credit);
            this.numScore= this.thisScore;
             this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[36].regInfo,
                mcont: "Lianlian Pay",
                credit:this.regInfo.creditRuleEntityList[36].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[36].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[36].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[37].regInfo,
                mcont: "美国",
                credit:this.regInfo.creditRuleEntityList[37].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[37].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[37].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[38].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.accountInfo.name),
                credit:this.regInfo.creditRuleEntityList[38].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[38].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[38].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[39].regInfo,
                mcont:this.VirtualInfo.accountInfo.routingNumber,
                credit:this.regInfo.creditRuleEntityList[39].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[39].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[39].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[40].regInfo,
                mcont: this.VirtualInfo.accountInfo.accountNumber,
                credit:this.regInfo.creditRuleEntityList[40].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[40].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[40].knowledgePoint
            })
        }
         // reg10
         if(mPage=='reg11_newus'||mPage=='reg12_newus'||mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+(+this.regInfo.creditRuleEntityList[41].credit
                            +this.regInfo.creditRuleEntityList[42].credit
                            +this.regInfo.creditRuleEntityList[43].credit
                            +this.regInfo.creditRuleEntityList[44].credit
                            +this.regInfo.creditRuleEntityList[45].credit
                            +this.regInfo.creditRuleEntityList[46].credit
                            +this.regInfo.creditRuleEntityList[47].credit
                            +this.regInfo.creditRuleEntityList[48].credit
                            +this.regInfo.creditRuleEntityList[49].credit);
                            
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[41].regInfo,
                mcont: this.VirtualInfo.accountInfo.cardNo,
                credit:this.regInfo.creditRuleEntityList[41].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[41].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[41].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[42].regInfo,
                mcont: this.VirtualInfo.accountInfo.cardValidity,
                credit:this.regInfo.creditRuleEntityList[42].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[42].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[42].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[43].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.accountInfo.name),
                credit:this.regInfo.creditRuleEntityList[43].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[43].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[43].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[44].regInfo,
                mcont:this.VirtualInfo.businessInfoEntity.postCode,
                credit:this.regInfo.creditRuleEntityList[44].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[44].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[44].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[45].regInfo,
                mcont: this.getPinyin(this.VirtualInfo.businessInfoEntity.state),
                credit:this.regInfo.creditRuleEntityList[45].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[45].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[45].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[46].regInfo,
                mcont: this.getPinyin(this.VirtualInfo.businessInfoEntity.city),
                credit:this.regInfo.creditRuleEntityList[46].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[46].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[46].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[47].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.addressTwo),
                credit:this.regInfo.creditRuleEntityList[47].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[47].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[47].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[48].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.addressOne),
                credit:this.regInfo.creditRuleEntityList[48].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[48].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[48].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[49].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.addressTwo),
                credit:this.regInfo.creditRuleEntityList[49].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[49].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[49].knowledgePoint
            })
        } 
        // reg11
        if(mPage=='reg12_newus'||mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[50].credit;
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[50].regInfo,
                mcont:'dfsgdf',
                credit:this.regInfo.creditRuleEntityList[50].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[50].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[50].knowledgePoint
            })
        }
        // reg12
        if(mPage=='reg13_newus'||mPage=='reg14_newus'||mPage=='reg15_newus'||mPage=='reg16_newus'||mPage=='reg17_newus'||mPage=='reg18_newus'||mPage=='reg19_newus'||mPage=='reg20_newus'||mPage=='reg21_newus'||mPage=='reg22_newus'||mPage=='reg23_newus'||mPage=='reg24_newus'||mPage=='reg25_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+(this.regInfo.creditRuleEntityList[51].credit
            +this.regInfo.creditRuleEntityList[52].credit
            +this.regInfo.creditRuleEntityList[53].credit
            );
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[51].regInfo,
                mcont:'上传正确',
                credit:this.regInfo.creditRuleEntityList[51].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[51].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[51].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[52].regInfo,
                mcont:'上传正确',
                credit:this.regInfo.creditRuleEntityList[52].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[52].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[52].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[53].regInfo,
                mcont:'上传正确',
                credit:this.regInfo.creditRuleEntityList[53].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[53].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[53].knowledgePoint
            })
        }
         // reg23
        if(mPage=='reg24_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[54].credit;
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[54].regInfo,
                mcont:this.VirtualInfo.accountInfo.backupPhone,
                credit:this.regInfo.creditRuleEntityList[54].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[54].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[54].knowledgePoint
            })
        }
        if(mPage=='reg24_newus'||mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
            this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[54].credit;
            this.numScore= this.thisScore;
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[54].regInfo,
                mcont:this.VirtualInfo.accountInfo.backupPhone,
                credit:this.regInfo.creditRuleEntityList[54].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[54].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[54].knowledgePoint
            })
        }
         // reg6
        if(mPage=='UScn'||mPage=='USen'||mPage=='UKcn'||mPage=='UKen'||mPage=='AUcn'||mPage=='AUen'||mPage=='JPcn'||mPage=='JPjp'||mPage=='CK1cn'||mPage=='CK2cn'||mPage=='CK3cn'||mPage=='CK1en'||mPage=='CK2en'||mPage=='CK3en'||mPage=='tax1'||mPage=='tax2'||mPage=='tax3'){
          this.thisScore= this.thisScore+(this.regInfo.creditRuleEntityList[56].credit
            +this.regInfo.creditRuleEntityList[57].credit
            +this.regInfo.creditRuleEntityList[58].credit
            +this.regInfo.creditRuleEntityList[59].credit
            +this.regInfo.creditRuleEntityList[60].credit
            +this.regInfo.creditRuleEntityList[61].credit
            +this.regInfo.creditRuleEntityList[62].credit
            +this.regInfo.creditRuleEntityList[63].credit
            +this.regInfo.creditRuleEntityList[64].credit
            +this.regInfo.creditRuleEntityList[65].credit
            +this.regInfo.creditRuleEntityList[66].credit
            +this.regInfo.creditRuleEntityList[67].credit
            +this.regInfo.creditRuleEntityList[68].credit
            +this.regInfo.creditRuleEntityList[69].credit
            +this.regInfo.creditRuleEntityList[70].credit
            +this.regInfo.creditRuleEntityList[71].credit
            +this.regInfo.creditRuleEntityList[72].credit
            +this.regInfo.creditRuleEntityList[55].credit);
            this.numScore= this.thisScore
            this.infoScore.push({
                name:this.regInfo.creditRuleEntityList[55].regInfo,
                mcont:'业务',
                credit:this.regInfo.creditRuleEntityList[55].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[55].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[55].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[56].regInfo,
                mcont:'否',
                credit:this.regInfo.creditRuleEntityList[56].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[56].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[56].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[57].regInfo,
                mcont:'Corporation',
                credit:this.regInfo.creditRuleEntityList[57].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[57].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[57].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[58].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.name),
                credit:this.regInfo.creditRuleEntityList[58].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[58].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[58].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[59].regInfo,
                mcont:'China',
                credit:this.regInfo.creditRuleEntityList[59].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[59].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[59].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[60].regInfo,
                mcont:'jdskaf',
                credit:this.regInfo.creditRuleEntityList[60].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[60].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[60].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[61].regInfo,
                mcont:'China',
                credit:this.regInfo.creditRuleEntityList[61].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[61].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[61].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[62].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.addressOne),
                credit:this.regInfo.creditRuleEntityList[62].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[62].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[62].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[63].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.addressTwo),
                credit:this.regInfo.creditRuleEntityList[63].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[63].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[63].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[64].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.city),
                credit:this.regInfo.creditRuleEntityList[64].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[64].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[64].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[65].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.state),
                credit:this.regInfo.creditRuleEntityList[65].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[65].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[65].knowledgePoint
            }
            ,{
                name:this.regInfo.creditRuleEntityList[66].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.businessInfoEntity.postCode),
                credit:this.regInfo.creditRuleEntityList[66].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[66].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[66].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[67].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.accountInfo.name),
                credit:this.regInfo.creditRuleEntityList[67].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[67].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[67].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[68].regInfo,
                mcont:'US',
                credit:this.regInfo.creditRuleEntityList[68].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[68].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[68].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[69].regInfo,
                mcont: "US",
                credit:this.regInfo.creditRuleEntityList[69].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[69].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[69].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[70].regInfo,
                mcont:this.getPinyin(this.VirtualInfo.accountInfo.name),
                credit:this.regInfo.creditRuleEntityList[70].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[70].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[70].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[71].regInfo,
                mcont:this.VirtualInfo.accountInfo.routingNumber,
                credit:this.regInfo.creditRuleEntityList[71].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[71].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[71].knowledgePoint
            },{
                name:this.regInfo.creditRuleEntityList[72].regInfo,
                mcont: this.VirtualInfo.accountInfo.accountNumber,
                credit:this.regInfo.creditRuleEntityList[72].credit,
                result:1,
                resultCont:this.regInfo.creditRuleEntityList[72].correctShow,
                knowledgePoint:this.regInfo.creditRuleEntityList[72].knowledgePoint
            })
        }
      },
         getBeforeAmazonRegAccountInfo(){
         this.$axios
        .get(this.interfaceJson.serverAddress+"/api/site/getBeforeAmazonRegAccountInfo?site="+"NEW_SELLER_"+sessionStorage.site)
        .then(res => {
        let data=res.data;
        if(data.code==0){
            this.AmazonRegAccountInfo=data.data;
            if(!this.AmazonRegAccountInfo){
              this.reexamination=false;
              sessionStorage.removeItem('pageArr');
              sessionStorage.removeItem('seCountry');
              sessionStorage.removeItem('ckCountry');
              sessionStorage.removeItem('ckAccountNumber');
              sessionStorage.removeItem('ckAccountHolderName');
              sessionStorage.removeItem('ckRoutingNumber');
              sessionStorage.removeItem('ckAccountNumberReEnter');
              sessionStorage.removeItem('tax_ogname');
              sessionStorage.removeItem('m_og_name');
              sessionStorage.removeItem('tax_ogcountry');
              sessionStorage.removeItem('m_og_country');
              sessionStorage.removeItem('tax_disregard');
              sessionStorage.removeItem('m_Disregarded_name');
              sessionStorage.removeItem('tax_addr1');
              sessionStorage.removeItem('m_tax_addr_1');
              sessionStorage.removeItem('tax_city1');
              sessionStorage.removeItem('m_tax_city');
              sessionStorage.removeItem('tax_addr2');
              sessionStorage.removeItem('m_tax_addr_2');
              sessionStorage.removeItem('m_isUSA');
              sessionStorage.removeItem('m_taxtype');
              sessionStorage.removeItem('m_benType');
              sessionStorage.removeItem('m_Permanent_country');
              sessionStorage.removeItem('m_tax_state');
              sessionStorage.removeItem('m_taxzipcode');
              sessionStorage.removeItem('m_Signature');
              sessionStorage.removeItem('tax_signature');
              sessionStorage.removeItem('m_tax_Date');
              sessionStorage.removeItem('tax_date');
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg1_us.html'
            }else{
              sessionStorage.m_loginData=JSON.stringify(data.data) 
              let arr=[]
              let reg0={}
              let reg1={}
              let reg2={}
              let reg3={}
              let reg4={}
              let reg5={}
              let reg6={}
              let reg7={}
              let reg8={}
              let reg9={}
              if(this.AmazonRegAccountInfo.step==25){
                this.reexamination=true;
                this.textCommonPop='已完成考核'
              }else if(this.AmazonRegAccountInfo.step>1){
                this.reexamination=true;
                this.textCommonPop='有未完成的考核'
              }
              if(this.AmazonRegAccountInfo.username){
                reg0.m_name=this.AmazonRegAccountInfo.username
              }
              if(this.AmazonRegAccountInfo.email){
                reg0.m_email=this.AmazonRegAccountInfo.email
              }
              
              if(this.AmazonRegAccountInfo.usCompanyInfoEntity){
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.displayName){
                   reg7.displayName=this.AmazonRegAccountInfo.usCompanyInfoEntity.displayName
                }
                //  手机号码
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.noRegPhone){
                   reg1.phone=this.AmazonRegAccountInfo.usCompanyInfoEntity.noRegPhone
                }
                // 公司地址-国家/地区
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyCountry){
                   reg2.companyCountry=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyCountry
                }
                 if(this.AmazonRegAccountInfo.usCompanyInfoEntity.phoneArea){
                   reg1.phoneArea=this.AmazonRegAccountInfo.usCompanyInfoEntity.phoneArea
                }
                //业务类型
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.businessType){
                   reg2.businessType=this.AmazonRegAccountInfo.usCompanyInfoEntity.businessType
                }
                //中文名字
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyChineseName){
                   reg2.companyEnglishName=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyChineseName
                }
                //英文名字
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyEnglishName){
                    reg2.companyEnglishName=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyEnglishName
                }
              }
              if(this.AmazonRegAccountInfo.usCompanyInfoEntity){
                //  手机号码
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.noRegPhone){
                   reg1.phone=this.AmazonRegAccountInfo.usCompanyInfoEntity.noRegPhone
                }
                // 公司地址-国家/地区
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyCountry){
                   reg2.companyCountry=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyCountry
                }
                //业务类型
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.businessType){
                   reg2.businessType=this.AmazonRegAccountInfo.usCompanyInfoEntity.businessType
                }
                //中文名字
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyChineseName){
                  reg2.companyChineseName=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyChineseName
                }
                //英文名字
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyEnglishName){
                  reg2.companyEnglishName=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyEnglishName
                }
                // 公司注册号码
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyRegNumber){
                  reg3.m_businessLicense=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyRegNumber
                }
                 //经营地址-邮编
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.postCode){
                  reg3.m_b_zipcode=this.AmazonRegAccountInfo.usCompanyInfoEntity.postCode
                }
                 //经营地址-省份
                 if(this.AmazonRegAccountInfo.usCompanyInfoEntity.state){
                  reg3.m_b_state=this.AmazonRegAccountInfo.usCompanyInfoEntity.state
                }
                 if(this.AmazonRegAccountInfo.usCompanyInfoEntity.city){
                  reg3.m_b_city=this.AmazonRegAccountInfo.usCompanyInfoEntity.city
                }
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.area){
                  reg3.m_b_area=this.AmazonRegAccountInfo.usCompanyInfoEntity.area
                }
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyAddressOne){
                  reg3.m_b_address1=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyAddressOne
                }
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.companyAddressTwo||this.AmazonRegAccountInfo.usCompanyInfoEntity.companyAddressOne){
                  reg3.m_b_address2=this.AmazonRegAccountInfo.usCompanyInfoEntity.companyAddressTwo||""
                }
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.verifyPhone){
                  reg3.m_phone=this.AmazonRegAccountInfo.usCompanyInfoEntity.verifyPhone
                }
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.firstName){
                  reg3.m_firstname=this.AmazonRegAccountInfo.usCompanyInfoEntity.firstName
                }
                if(this.AmazonRegAccountInfo.usCompanyInfoEntity.lastName){
                  reg3.m_lastname=this.AmazonRegAccountInfo.usCompanyInfoEntity.lastName
                }
              }
               
              if(this.AmazonRegAccountInfo.usIdVerifyEntity){
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.nationality){
                  reg4.m_b_nationality=this.AmazonRegAccountInfo.usIdVerifyEntity.nationality
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.birthplace){
                  reg4.m_b_birthplace=this.AmazonRegAccountInfo.usIdVerifyEntity.birthplace
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.birthday){
                  reg4.m_b_birthday=this.AmazonRegAccountInfo.usIdVerifyEntity.birthday
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.docNumber){
                  reg4.m_b_docNumber=this.AmazonRegAccountInfo.usIdVerifyEntity.docNumber
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.docExpiryDate){
                  reg4.m_b_docExpiryDate=this.AmazonRegAccountInfo.usIdVerifyEntity.docExpiryDate
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.idCountrySelect){
                  reg4.m_b_idCountrySelect=this.AmazonRegAccountInfo.usIdVerifyEntity.idCountrySelect
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.surname){
                  reg4.m_b_surname=this.AmazonRegAccountInfo.usIdVerifyEntity.surname
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.idCardName){
                  reg4.m_b_idCardName=this.AmazonRegAccountInfo.usIdVerifyEntity.idCardName
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.postCode){
                  reg4.m_l_zipcode=this.AmazonRegAccountInfo.usIdVerifyEntity.postCode
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.state){
                  reg4.m_l_state=this.AmazonRegAccountInfo.usIdVerifyEntity.state
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.city){
                  reg4.m_l_city=this.AmazonRegAccountInfo.usIdVerifyEntity.city
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.area){
                  reg4.m_l_area=this.AmazonRegAccountInfo.usIdVerifyEntity.area
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.liveAddressOne){
                  reg4.m_l_address1=this.AmazonRegAccountInfo.usIdVerifyEntity.liveAddressOne
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.liveAddressTwo||this.AmazonRegAccountInfo.usIdVerifyEntity.liveAddressOne){
                  reg4.m_l_address2=this.AmazonRegAccountInfo.usIdVerifyEntity.liveAddressTwo||''
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.legalPhone){
                  reg4.m_l_phone=this.AmazonRegAccountInfo.usIdVerifyEntity.legalPhone
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.benefitOwner){
                  reg4.m_b_benefitOwner=this.AmazonRegAccountInfo.usIdVerifyEntity.benefitOwner
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.legalPerson){
                  reg4.m_b_legalPerson=this.AmazonRegAccountInfo.usIdVerifyEntity.legalPerson
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.addBeneficiary){
                  reg4.m_b_addBeneficiary=this.AmazonRegAccountInfo.usIdVerifyEntity.addBeneficiary
                }
                if(this.AmazonRegAccountInfo.usIdVerifyEntity.cvfPhoneNum){
                   reg9.m_phone= this.AmazonRegAccountInfo.usIdVerifyEntity.cvfPhoneNum
                }
              }
              
              if(this.AmazonRegAccountInfo.usBillEntity){
                if(this.AmazonRegAccountInfo.usBillEntity.account){
                  reg5.m_account  =this.AmazonRegAccountInfo.usBillEntity.account
                }
                if(this.AmazonRegAccountInfo.usBillEntity.country){
                  reg5.m_country=this.AmazonRegAccountInfo.usBillEntity.country
                }
                if(this.AmazonRegAccountInfo.usBillEntity.identifier){
                  reg5.m_identifier=this.AmazonRegAccountInfo.usBillEntity.identifier
                }
                if(this.AmazonRegAccountInfo.usBillEntity.institutionName){
                  reg5.m_institutionName=this.AmazonRegAccountInfo.usBillEntity.institutionName
                }
                 if(this.AmazonRegAccountInfo.usBillEntity.name){
                  reg5.m_name=this.AmazonRegAccountInfo.usBillEntity.name
                }
              }
              if(this.AmazonRegAccountInfo.newBillEntity){
                 if(this.AmazonRegAccountInfo.newBillEntity.newCountry){
                  sessionStorage.seCountry=this.AmazonRegAccountInfo.newBillEntity.newCountry
                }
                if(this.AmazonRegAccountInfo.newBillEntity.account){
                  sessionStorage.ckAccountNumber=this.AmazonRegAccountInfo.newBillEntity.account
                }
                if(this.AmazonRegAccountInfo.newBillEntity.country){
                  sessionStorage.ckCountry=this.AmazonRegAccountInfo.newBillEntity.country
                }
                if(this.AmazonRegAccountInfo.newBillEntity.identifier){
                  sessionStorage.ckRoutingNumber=this.AmazonRegAccountInfo.newBillEntity.identifier
                }
                if(this.AmazonRegAccountInfo.newBillEntity.name){
                 sessionStorage.ckAccountHolderName=this.AmazonRegAccountInfo.newBillEntity.name
                }
              }
               if(this.AmazonRegAccountInfo.taxInfoEntity){
                 if(this.AmazonRegAccountInfo.taxInfoEntity.ogName){
                  sessionStorage.tax_ogname=this.AmazonRegAccountInfo.taxInfoEntity.ogName
                  sessionStorage.m_og_name=this.AmazonRegAccountInfo.taxInfoEntity.ogName
                }
                 if(this.AmazonRegAccountInfo.taxInfoEntity.ogCountry){
                sessionStorage.tax_ogcountry=this.AmazonRegAccountInfo.taxInfoEntity.ogCountry
                  sessionStorage.m_og_country=this.AmazonRegAccountInfo.taxInfoEntity.ogCountry
                  
                }
                 if(this.AmazonRegAccountInfo.taxInfoEntity.disregardedName){
                  sessionStorage.tax_disregard=this.AmazonRegAccountInfo.taxInfoEntity.disregardedName
                  sessionStorage.m_Disregarded_name=this.AmazonRegAccountInfo.taxInfoEntity.disregardedName
                }
                 if(this.AmazonRegAccountInfo.taxInfoEntity.street){
                  sessionStorage.tax_addr1=this.AmazonRegAccountInfo.taxInfoEntity.street
                  sessionStorage.m_tax_addr_1=this.AmazonRegAccountInfo.taxInfoEntity.street
                }
                 if(this.AmazonRegAccountInfo.taxInfoEntity.apartment){
                  sessionStorage.tax_addr2=this.AmazonRegAccountInfo.taxInfoEntity.apartment
                  sessionStorage.m_tax_addr_2=this.AmazonRegAccountInfo.taxInfoEntity.apartment
                  
                }
                 if(this.AmazonRegAccountInfo.taxInfoEntity.city){
                  sessionStorage.tax_city1=this.AmazonRegAccountInfo.taxInfoEntity.city
                  sessionStorage.m_tax_city=this.AmazonRegAccountInfo.taxInfoEntity.city
                }
                if(this.AmazonRegAccountInfo.taxInfoEntity.isUsa){
                  sessionStorage.m_isUSA=this.AmazonRegAccountInfo.taxInfoEntity.isUsa
                }
                if(this.AmazonRegAccountInfo.taxInfoEntity.taxType){
                  sessionStorage.m_taxtype=this.AmazonRegAccountInfo.taxInfoEntity.taxType
                }
                if(this.AmazonRegAccountInfo.taxInfoEntity.benType){
                  sessionStorage.m_benType=this.AmazonRegAccountInfo.taxInfoEntity.benType
                }
                if(this.AmazonRegAccountInfo.taxInfoEntity.permanentCountry){
                  sessionStorage.m_Permanent_country=this.AmazonRegAccountInfo.taxInfoEntity.permanentCountry
                }
                if(this.AmazonRegAccountInfo.taxInfoEntity.state){
                  sessionStorage.m_tax_state=this.AmazonRegAccountInfo.taxInfoEntity.state
                }
                if(this.AmazonRegAccountInfo.taxInfoEntity.postCode){
                  sessionStorage.m_taxzipcode=this.AmazonRegAccountInfo.taxInfoEntity.postCode
                }
                if(this.AmazonRegAccountInfo.taxInfoEntity.signature){
                  sessionStorage.m_Signature=this.AmazonRegAccountInfo.taxInfoEntity.signature
                  sessionStorage.tax_signature=this.AmazonRegAccountInfo.taxInfoEntity.signature
                }
                 if(this.AmazonRegAccountInfo.taxInfoEntity.taxDate){
                  sessionStorage.m_tax_Date=this.AmazonRegAccountInfo.taxInfoEntity.taxDate
                  sessionStorage.tax_date=this.AmazonRegAccountInfo.taxInfoEntity.taxDate
                }
              }
              if(this.AmazonRegAccountInfo.usCardInfoEntity){
                if(this.AmazonRegAccountInfo.usCardInfoEntity.cardNumber){
                  reg6.m_b_cardNo=this.AmazonRegAccountInfo.usCardInfoEntity.cardNumber
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.expirationDate){
                  reg6.m_b_expirationDate=this.AmazonRegAccountInfo.usCardInfoEntity.expirationDate
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.holderName){
                  reg6.m_b_holderName=this.AmazonRegAccountInfo.usCardInfoEntity.holderName
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.postCode){
                  reg6.m_zipcode=this.AmazonRegAccountInfo.usCardInfoEntity.postCode
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.state){
                  reg6.m_state=this.AmazonRegAccountInfo.usCardInfoEntity.state
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.city){
                  reg6.m_city=this.AmazonRegAccountInfo.usCardInfoEntity.city
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.area){
                  reg6.m_area=this.AmazonRegAccountInfo.usCardInfoEntity.area
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.addressOne){
                  reg6.m_address1=this.AmazonRegAccountInfo.usCardInfoEntity.addressOne
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.addressTwo||this.AmazonRegAccountInfo.usCardInfoEntity.addressOne){
                  reg6.m_address2=this.AmazonRegAccountInfo.usCardInfoEntity.addressTwo||''
                }
                if(this.AmazonRegAccountInfo.usCardInfoEntity.flag){
                  reg6.m_b_flag=this.AmazonRegAccountInfo.usCardInfoEntity.flag
                }
              }
              if(this.AmazonRegAccountInfo.usIdUploadEntity){
                if(this.AmazonRegAccountInfo.usIdUploadEntity.idPhotoFront){
                  reg8.m_idpic_front=this.AmazonRegAccountInfo.usIdUploadEntity.idPhotoFront
                }
                if(this.AmazonRegAccountInfo.usIdUploadEntity.idPhotoBack){
                  reg8.m_idpic_back=this.AmazonRegAccountInfo.usIdUploadEntity.idPhotoBack
                }
                if(this.AmazonRegAccountInfo.usIdUploadEntity.businessPhoto){
                  reg8.m_bupic=this.AmazonRegAccountInfo.usIdUploadEntity.businessPhoto
                }
               
                
              }
              
              if(JSON.stringify(reg0)!='{}'){
                arr.push(reg0)
              }
              if(JSON.stringify(reg1)!='{}'){
                arr.push(reg1)
              }
              if(JSON.stringify(reg2)!='{}'){
               
                arr.push(reg2)
              }
              if(JSON.stringify(reg3)!='{}'){
                arr.push(reg3)
              }
              if(JSON.stringify(reg4)!='{}'){
                arr.push(reg4)
              }
              if(JSON.stringify(reg5)!='{}'){
                arr.push(reg5)
              }
              if(JSON.stringify(reg6)!='{}'){
                arr.push(reg6)
              }
              if(JSON.stringify(reg7)!='{}'){
                arr.push(reg7)
              }
              if(JSON.stringify(reg8)!='{}'){
                arr.push(reg8)
              }
              if(JSON.stringify(reg9)!='{}'){
                arr.push(reg9)
              }
              sessionStorage.pageArr=JSON.stringify(arr)
            }
        }
        });
       
      },
      goStep(){
          if(this.AmazonRegAccountInfo.step<=24){
             this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/reg'+this.AmazonRegAccountInfo.step+'_us.html'
             this.isNews=true
          }else{
              this.isNews=false
            if(this.AmazonRegAccountInfo.step==25){
               this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/UScn.html'
            }else if(this.AmazonRegAccountInfo.step==26){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/tax1.html'
            }else if(this.AmazonRegAccountInfo.step==27){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/tax2.html'
            }else if(this.AmazonRegAccountInfo.step==28){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/tax3.html'
            }else if(this.AmazonRegAccountInfo.step==29){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/UScn.html'
            }else if(this.AmazonRegAccountInfo.step==30){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/CK1en.html'
            }else if(this.AmazonRegAccountInfo.step==31){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/CK2en.html'
            }else if(this.AmazonRegAccountInfo.step==32){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/CK3en.html'
            }else if(this.AmazonRegAccountInfo.step==33){
              this.view.src=this.interfaceJson.ipUrl+'/siteNewUs/us/UScn.html'
            }
          }
      },
      getVirtualInfo(){
        this.$axios
          .get(this.interfaceJson.serverAddress+"/api/site/getVirtualInfo")
          .then(res => {
          let data=res.data;
          if(data.code==0){
            this.VirtualInfo=data.data
            sessionStorage.setItem('virtualInfo',JSON.stringify(data.data.accountInfo))
            sessionStorage.setItem('accountAddress',JSON.stringify(data.data.accountAddress))
            sessionStorage.setItem('businessInfoEntity',JSON.stringify(data.data.businessInfoEntity))
            sessionStorage.setItem('virtual',JSON.stringify(data.data))
          }
        });
      },
      getSite(){
          this.$axios
          .get(this.interfaceJson.serverAddress+"/api/site/getVirtualConfigs?site=newus")
          .then(res => {
          let data=res.data;
          if(data.code==0){
            this.regInfo=data.data
            // console.log(this.calcs(this.regInfo.creditRuleEntityList).toFixed(2))
            sessionStorage.setItem('regInfo',JSON.stringify(this.regInfo))
            if(this.regInfo.virtualConfigEntityList[0].helpBtn==0){
              this.isHelp=false;
            }else{
              this.isHelp=true;
            }
             if(this.regInfo.virtualConfigEntityList[0].knowledgeBtn==0){
              this.isChis=false;
            }else{
              this.isChis=true;
            }
          }
          });
      },
     downloadCodeImg(e){
          console.log('下载图片')
          var a = document.createElement('a')
         // 设置图片地址
          if(e==0){
            a.download =  '身份证正面';
            a.href = this.interfaceJson.ipUrl+'/virtualPic/'+this.VirtualInfo.num+'/身份证正面.jpg';
          }else if(e==1){
            a.download = '身份证背面';
            a.href = this.interfaceJson.ipUrl+'/virtualPic/'+this.VirtualInfo.num+'/身份证背面.jpg';
          }else{
            a.download = '营业执照正本'
            a.href = this.interfaceJson.ipUrl+'/virtualPic/'+this.VirtualInfo.num+'/营业执照正本.jpg';
          }
          a.click();
       },
      getScoreList(){
        let pageArr=null;
        if(sessionStorage.pageArr){
          pageArr= JSON.parse(sessionStorage.pageArr);
        }
        this.numScore=0;
        this.thisScore=0;
        this.infoScore=[];
        if(pageArr){
         if(pageArr[0]){ 
              //  法人名字评分
          if(pageArr[0].m_name){
              this.numScore= this.numScore + this.regInfo.creditRuleEntityList[0].credit;
            let reg_us={
                  name:this.regInfo.creditRuleEntityList[0].regInfo,
                  mcont:pageArr[0].m_name,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.regInfo.creditRuleEntityList[0].knowledgePoint
              }
              let isTrue=  this.YourName_ok(pageArr[0].m_name ,this.VirtualInfo.accountInfo.name)
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[0].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[0].credit
                reg_us.result=1
                reg_us.resultCont=this.regInfo.creditRuleEntityList[0].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[0].errorShow
                this.infoScore.push(reg_us)
            }
          }
          //  邮箱评分
          if(pageArr[0].m_email){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[1].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[1].regInfo,
                  mcont:pageArr[0].m_email,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.regInfo.creditRuleEntityList[1].knowledgePoint
              }
            let isTrue=  this.email_ok(pageArr[0].m_email ,this.VirtualInfo.accountInfo.email)
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[1].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[1].credit
                reg_us.result=1
                reg_us.resultCont=this.regInfo.creditRuleEntityList[1].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[1].errorShow
                this.infoScore.push(reg_us)
            }
          }
        }
        //  reg3
        if(pageArr[1]){
          //  手机号码
          if(pageArr[1].phone){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[3].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[3].regInfo,
                  mcont:pageArr[1].phone,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.regInfo.creditRuleEntityList[3].knowledgePoint
              }
            let isTrue = this.phone_ok(pageArr[1].phone,this.VirtualInfo.accountInfo.phone) 
            if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[3].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[3].credit
                reg_us.resultCont=this.regInfo.creditRuleEntityList[3].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[3].errorShow
                reg_us.result=0
                this.infoScore.push(reg_us)
            }
          }
          if(pageArr[1].phoneArea){
            let va='';
             let isTrue =false;
             if(pageArr[1].phoneArea.substr(0, 1)=='+'){
                isTrue =pageArr[1].phoneArea== '+'+this.VirtualInfo.accountInfo.phoneArea
                va=pageArr[1].phoneArea
              }else{
                 isTrue =pageArr[1].phoneArea== this.VirtualInfo.accountInfo.phoneArea
                 va='+'+pageArr[1].phoneArea
              }
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[2].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[2].regInfo,
                  mcont:va,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.regInfo.creditRuleEntityList[2].knowledgePoint
              }
             
            if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[2].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[2].credit
                reg_us.resultCont=this.regInfo.creditRuleEntityList[2].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[2].errorShow
                reg_us.result=0
                this.infoScore.push(reg_us)
            }
          }
        }
        //  reg4
        if(pageArr[2]){
          // 公司地址-国家/地区
          if(pageArr[2].companyCountry){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[4].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[4].regInfo,
                mcont:pageArr[2].companyCountry,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[4].knowledgePoint
            }
           let isTrue=  this.countrycn_ok(pageArr[2].companyCountry) 
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[4].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[4].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[4].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[4].errorShow
              this.infoScore.push(reg_us)
           }
         }
         
          //业务类型
          if(pageArr[2].businessType){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[5].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[5].regInfo,
                mcont:pageArr[2].businessType,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[5].knowledgePoint
            }
           let isTrue=  pageArr[2].businessType=='Privately-owned business'||pageArr[2].businessType=='私人企业'||pageArr[2].businessType=='私有企业'
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[5].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[5].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[5].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[5].errorShow
              this.infoScore.push(reg_us)
           }
         }
           
         //企业名称-英文
          if(pageArr[2].companyEnglishName){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[6].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[6].regInfo,
                mcont:pageArr[2].companyEnglishName,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[6].knowledgePoint
            }
           let isTrue=  this.businessName_ok(pageArr[2].companyEnglishName)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[6].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[6].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[6].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
               reg_us.resultCont=this.regInfo.creditRuleEntityList[6].errorShow
              this.infoScore.push(reg_us)
           }
         }
         //企业名称-中文
          if(pageArr[2].companyChineseName){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[7].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[7].regInfo,
                mcont:pageArr[2].companyChineseName,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[7].knowledgePoint
            }
           let isTrue= pageArr[2].companyChineseName==this.VirtualInfo.businessInfoEntity.name
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[7].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[7].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[7].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[7].errorShow
              this.infoScore.push(reg_us)
           }
         }
          
        } 
        // reg5
        if(pageArr[3]){
         // 公司注册号码
          if(pageArr[3].m_businessLicense){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[8].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[8].regInfo,
                mcont:pageArr[3].m_businessLicense,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[8].knowledgePoint
            }
           let isTrue=  pageArr[3].m_businessLicense ==this.VirtualInfo.businessInfoEntity.societyCode
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[8].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[8].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[8].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[8].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          //经营地址-邮编
          if(pageArr[3].m_b_zipcode){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[9].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[9].regInfo,
                mcont:pageArr[3].m_b_zipcode,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[9].knowledgePoint
            }
           let isTrue= this.pincode_ok(pageArr[3].m_b_zipcode,this.VirtualInfo.businessInfoEntity.postCode)
           if(isTrue){
            this.thisScore =this.thisScore+this.regInfo.creditRuleEntityList[9].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[9].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[9].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[9].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          //经营地址-省份
          if(pageArr[3].m_b_state){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[10].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[10].regInfo,
                mcont:pageArr[3].m_b_state,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[10].knowledgePoint
            }
           let isTrue=  this.Nstate_ok(pageArr[3].m_b_state,this.VirtualInfo.businessInfoEntity.state)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[10].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[10].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[10].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[10].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //经营地址-城市
          if(pageArr[3].m_b_city){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[11].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[11].regInfo,
                mcont:pageArr[3].m_b_city,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[11].knowledgePoint
            }
           let isTrue= this.Ncity_ok(pageArr[3].m_b_city,this.VirtualInfo.businessInfoEntity.city)
           if(isTrue){
               this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[11].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[11].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[11].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
               reg_us.resultCont=this.regInfo.creditRuleEntityList[11].errorShow
              this.infoScore.push(reg_us)
           }
         }
        //  经营地址-区域
          if(pageArr[3].m_b_area){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[12].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[12].regInfo,
                  mcont:pageArr[3].m_b_area,
                  credit:null,
                  resultCont:'',
                  result:null,
                  knowledgePoint:this.regInfo.creditRuleEntityList[12].knowledgePoint
              }
              let ds=null
              if(this.VirtualInfo.businessInfoEntity.addressTwo){
                ds= this.VirtualInfo.businessInfoEntity.addressTwo 
              }else{
                ds= this.VirtualInfo.businessInfoEntity.city
              }
              let isTrue=  this.Ndistrict_ok(pageArr[3].m_b_area,ds)
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[12].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[12].credit
                reg_us.resultCont=this.regInfo.creditRuleEntityList[12].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                this.infoScore.push(reg_us)
                reg_us.resultCont=this.regInfo.creditRuleEntityList[12].errorShow
            }
          }
          // 经营地址-地址行1
          if(pageArr[3].m_b_address1){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[13].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[13].regInfo,
                  mcont:pageArr[3].m_b_address1,
                  credit:null,
                  resultCont:'',
                  result:null,
                  knowledgePoint:this.regInfo.creditRuleEntityList[13].knowledgePoint
              }
              let isTrue= this.Naddress1_ok(pageArr[3].m_b_address1) 
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[13].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[13].credit
                reg_us.resultCont=this.regInfo.creditRuleEntityList[13].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                this.infoScore.push(reg_us)
                reg_us.resultCont=this.regInfo.creditRuleEntityList[13].errorShow
            }
          }
          // 经营地址-地址行2
          if(pageArr[3].m_b_address2||pageArr[3].m_b_address1){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[14].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[14].regInfo,
                  mcont:pageArr[3].m_b_address2||'未填写',
                  credit:null,
                  resultCont:'',
                  result:null,
                  knowledgePoint:this.regInfo.creditRuleEntityList[14].knowledgePoint
              }
              let isTrue= this.Naddress2_ok(pageArr[3].m_b_address2) 
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[14].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[14].credit
                reg_us.resultCont=this.regInfo.creditRuleEntityList[14].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                this.infoScore.push(reg_us)
                reg_us.resultCont=this.regInfo.creditRuleEntityList[14].errorShow
            }
          }
           //验证号码
          if(pageArr[3].m_phone){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[15].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[15].regInfo,
                  mcont:pageArr[3].m_phone,
                  credit:null,
                  resultCont:'',
                  result:null,
                  knowledgePoint:this.regInfo.creditRuleEntityList[15].knowledgePoint
              }
            let isTrue= this.phone_ok(pageArr[3].m_phone ,this.VirtualInfo.accountInfo.phone)
            if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[15].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[15].credit
                reg_us.result=1
                reg_us.resultCont=this.regInfo.creditRuleEntityList[15].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[15].errorShow
                reg_us.result=0
                this.infoScore.push(reg_us)
            }
          }
          //主要联系人-名字
          if(pageArr[3].m_firstname){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[16].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[16].regInfo,
                  mcont:pageArr[3].m_firstname,
                  credit:null,
                  resultCont:'',
                  result:null,
                  knowledgePoint:this.regInfo.creditRuleEntityList[16].knowledgePoint
              }
            let isTrue=  this.firstname_ok(pageArr[3].m_firstname,this.VirtualInfo.accountInfo.name)
            if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[16].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[16].credit
                reg_us.result=1
                reg_us.resultCont=this.regInfo.creditRuleEntityList[16].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[16].errorShow
                this.infoScore.push(reg_us)
            }
          }
           //主要联系人-姓氏
          if(pageArr[3].m_lastname){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[17].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[17].regInfo,
                  mcont:pageArr[3].m_lastname,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.regInfo.creditRuleEntityList[17].knowledgePoint
              }
            
            let isTrue=  this.lastname_ok(pageArr[3].m_lastname,this.VirtualInfo.accountInfo.name)
            
            if(isTrue && pageArr[3].m_b_flag!=0){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[17].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[17].credit
                reg_us.result=1
                reg_us.resultCont=this.regInfo.creditRuleEntityList[17].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[17].errorShow
                this.infoScore.push(reg_us)
            }
          }
        }
        // reg6
        if(pageArr[4]){
             //个人信息-国籍
          if(pageArr[4].m_b_nationality!=null){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[18].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[18].regInfo,
                  mcont:pageArr[4].m_b_nationality,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.regInfo.creditRuleEntityList[18].knowledgePoint
              }
            let isTrue= this.countrycn_ok(pageArr[4].m_b_nationality) 
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[18].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[18].credit
                reg_us.result=1
                reg_us.resultCont=this.regInfo.creditRuleEntityList[18].correctShow
                this.infoScore.push(reg_us)
              
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[18].errorShow
                this.infoScore.push(reg_us)
            }
          }
             //个人信息-出生地
          if(pageArr[4].m_b_birthplace!=null){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[19].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[19].regInfo,
                  mcont:pageArr[4].m_b_birthplace,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.regInfo.creditRuleEntityList[19].knowledgePoint
              }
            let isTrue=  this.countrycn_ok(pageArr[4].m_b_birthplace) 
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[19].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[19].credit
                reg_us.result=1
                reg_us.resultCont=this.regInfo.creditRuleEntityList[19].correctShow
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[19].errorShow
                this.infoScore.push(reg_us)
            }
          }
            //个人信息-出生日期
          if(pageArr[4].m_b_birthday!=null){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[20].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[20].regInfo,
                  mcont:pageArr[4].m_b_birthday,
                  credit:null,
                  result:null,
                  resultCont:'',
                  knowledgePoint:this.regInfo.creditRuleEntityList[20].knowledgePoint
              }
            let isTrue=  this.yxdate_ok(pageArr[4].m_b_birthday ,this.VirtualInfo.accountInfo.birthday)
            if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[20].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[20].credit
                reg_us.resultCont=this.regInfo.creditRuleEntityList[20].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[20].errorShow
                reg_us.result=0
                this.infoScore.push(reg_us)
            }
          }
          //  个人信息-身份证号码
         if(pageArr[4].m_b_docNumber!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[21].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[21].regInfo,
                mcont:pageArr[4].m_b_docNumber,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[21].knowledgePoint
            }
           let isTrue=  this.docNumber(pageArr[4].m_b_docNumber,this.VirtualInfo.accountInfo.idNum)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[21].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[21].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[21].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.regInfo.creditRuleEntityList[21].errorShow
           }
         }
          // 个人信息-有效期
         if(pageArr[4].m_b_docExpiryDate!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[22].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[22].regInfo,
                mcont:pageArr[4].m_b_docExpiryDate,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[22].knowledgePoint
            }
           let isTrue=  this.yxdate_ok(pageArr[4].m_b_docExpiryDate,this.VirtualInfo.accountInfo.idValidity)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[22].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[22].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[22].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.regInfo.creditRuleEntityList[22].errorShow
           }
         }
         //  个人信息-签发国
          if(pageArr[4].m_b_idCountrySelect!=null){
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[23].credit
              let reg_us={
                  name:this.regInfo.creditRuleEntityList[23].regInfo,
                  mcont:pageArr[4].m_b_idCountrySelect,
                  credit:null,
                  resultCont:'',
                  result:null,
                  knowledgePoint:this.regInfo.creditRuleEntityList[23].knowledgePoint
              }
              let isTrue=  pageArr[4].m_b_idCountrySelect=='CN'
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[23].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[23].credit
                reg_us.resultCont=this.regInfo.creditRuleEntityList[23].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.result=0
                this.infoScore.push(reg_us)
                reg_us.resultCont=this.regInfo.creditRuleEntityList[23].errorShow
            }
          }
            // 个人信息-姓
          if(pageArr[4].m_b_surname!=null ||pageArr[4].m_b_nationality){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[24].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[24].regInfo,
                mcont:pageArr[4].m_b_surname,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[24].knowledgePoint
            }
           let isTrue=  this.cnlastname_ok(pageArr[4].m_b_surname,this.VirtualInfo.accountInfo.name)
           if(isTrue &&this.countrycn_ok(pageArr[4].m_b_nationality)){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[24].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[24].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[24].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.regInfo.creditRuleEntityList[24].errorShow
           }
         }
         // 个人信息-名字
         if(pageArr[4].m_b_idCardName!=null ||pageArr[4].m_b_nationality){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[25].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[25].regInfo,
                mcont:pageArr[4].m_b_idCardName,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[24].knowledgePoint
            }
            
           let isTrue=  this.cnfirstname_ok(pageArr[4].m_b_idCardName,this.VirtualInfo.accountInfo.name)
           if(isTrue &&this.countrycn_ok(pageArr[4].m_b_nationality)){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[25].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[25].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[25].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.regInfo.creditRuleEntityList[25].errorShow
           }
         }
          // 居住地址-邮编
          if(pageArr[4].m_l_zipcode!=null ){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[26].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[26].regInfo,
                mcont:pageArr[4].m_l_zipcode,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[26].knowledgePoint
            }
            let isTrue=  this.pincode_ok(pageArr[4].m_l_zipcode,this.VirtualInfo.businessInfoEntity.postCode)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[26].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[26].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[26].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.regInfo.creditRuleEntityList[26].errorShow
           }
         }
           //  居住地址-省份
          if(pageArr[4].m_l_state!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[27].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[27].regInfo,
                mcont:pageArr[4].m_l_state,
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[27].knowledgePoint
            }
           let isTrue= this.Nstate_ok(pageArr[4].m_l_state,this.VirtualInfo.businessInfoEntity.state)||this.state_ok(pageArr[4].m_l_state,this.VirtualInfo.businessInfoEntity.state)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[27].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[27].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[27].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[27].errorShow
              this.infoScore.push(reg_us)
           }
         }
            //  居住地址-城市
          if(pageArr[4].m_l_city){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[28].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[28].regInfo,
                mcont:pageArr[4].m_l_city,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[28].knowledgePoint
            }
           let isTrue= this.Ncity_ok(pageArr[4].m_l_city,this.VirtualInfo.businessInfoEntity.city)||this.city_ok(pageArr[4].m_l_city,this.VirtualInfo.businessInfoEntity.city)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[28].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[28].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[28].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[28].errorShow
              this.infoScore.push(reg_us)
           }
         }
           //  居住地址-区域
          if(pageArr[4].m_l_area){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[29].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[29].regInfo,
                mcont:pageArr[4].m_l_area,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[29].knowledgePoint
            }
              let ds=null
              if(this.VirtualInfo.businessInfoEntity.addressTwo){
                ds= this.VirtualInfo.businessInfoEntity.addressTwo 
              }else{
                ds= this.VirtualInfo.businessInfoEntity.city
              }
              let isTrue=  this.Ndistrict_ok(pageArr[4].m_l_area,ds)||this.district1_ok(pageArr[4].m_l_area,ds)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[29].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[29].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[29].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[29].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          //  居住地址-地址行1
          if(pageArr[4].m_l_address1){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[30].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[30].regInfo,
                mcont:pageArr[4].m_l_address1,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[30].knowledgePoint
            }
           let isTrue=this.Naddress1_ok(pageArr[4].m_l_address1) 
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[30].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[30].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[30].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.regInfo.creditRuleEntityList[30].errorShow
           }
         }
            //  居住地址-地址行2
          if(pageArr[4].m_l_address2||pageArr[4].m_l_address1){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[31].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[31].regInfo,
                mcont:pageArr[4].m_l_address2||'未填写',
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[31].knowledgePoint
            }
            let isTrue=this.Naddress2_ok(pageArr[4].m_l_address2) 
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[31].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[31].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[31].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[31].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
           //  手机号码
          if(pageArr[4].m_l_phone){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[32].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[32].regInfo,
                mcont:pageArr[4].m_l_phone,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[32].knowledgePoint
            }
           let isTrue=  this.phone_ok(pageArr[4].m_l_phone ,this.VirtualInfo.accountInfo.phone)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[32].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[32].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[32].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[32].errorShow
              this.infoScore.push(reg_us)
           }
         }
          //  收益所有人
          if(pageArr[4].m_b_benefitOwner!=null){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[33].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[33].regInfo,
                mcont:pageArr[4].m_b_benefitOwner=='1' ?'已勾选':'未勾选',
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[33].knowledgePoint
            }
           let isTrue=  pageArr[4].m_b_benefitOwner=='1'
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[33].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[33].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[33].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[33].errorShow
              this.infoScore.push(reg_us)
           }
         }
          //  法人代表
          if(pageArr[4].m_b_legalPerson!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[34].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[34].regInfo,
                mcont:pageArr[4].m_b_legalPerson,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[34].knowledgePoint
            }
           if(pageArr[4].m_b_legalPerson==1){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[34].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[34].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[34].correctShow
              reg_us.result=1
               reg_us.mcont='已勾选'
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[34].errorShow
              reg_us.result=0
               reg_us.mcont='未勾选'
              this.infoScore.push(reg_us)
           }
         }
          //  添加受益人
          if(pageArr[4].m_b_addBeneficiary!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[35].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[35].regInfo,
                mcont:pageArr[4].m_b_addBeneficiary,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[35].knowledgePoint
            }
           if(pageArr[4].m_b_addBeneficiary==1){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[35].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[35].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[35].correctShow
              reg_us.result=1
              reg_us.mcont='公司收益人'
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[35].errorShow
              reg_us.result=0
              reg_us.mcont='未添加收益人'
              this.infoScore.push(reg_us)
           }
         }
        }
        if(pageArr[5]){
           //  金融机构名称
          if(pageArr[5].m_institutionName!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[36].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[36].regInfo,
                mcont:pageArr[5].m_institutionName,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[36].knowledgePoint
            }
            let isTrue=  pageArr[5].m_institutionName=='Lianlian Pay'
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[36].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[36].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[36].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[36].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
        //  选择收款账户所在国家
         if(pageArr[5].m_country!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[37].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[37].regInfo,
                mcont:pageArr[5].m_country,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[37].knowledgePoint
            }
           if(pageArr[5].m_country=='US'||pageArr[5].m_country=='美国'){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[37].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[37].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[37].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[37].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          //  持卡人姓名
         if(pageArr[5].m_name!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[38].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[38].regInfo,
                mcont:pageArr[5].m_name,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[38].knowledgePoint
            }
             let isTrue= this.YourName_ok(pageArr[5].m_name ,this.VirtualInfo.accountInfo.name )
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[38].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[38].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[38].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[38].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
        //  填入收款账户9位数的银行识别代码
         if(pageArr[5].m_identifier!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[39].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[39].regInfo,
                mcont:pageArr[5].m_identifier,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[39].knowledgePoint
            }
             let isTrue= pageArr[5].m_identifier==this.VirtualInfo.accountInfo.routingNumber
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[39].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[39].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[39].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[39].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          //  银行账户
         if(pageArr[5].m_account!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[40].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[40].regInfo,
                mcont:pageArr[5].m_account,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[40].knowledgePoint
            }
             let isTrue= pageArr[5].m_account==this.VirtualInfo.accountInfo.accountNumber
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[40].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[40].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[40].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[40].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
        }
        // reg7
        if(pageArr[6]){
           //  账单信息-信用卡号
          if(pageArr[6].m_b_cardNo!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[41].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[41].regInfo,
                mcont:pageArr[6].m_b_cardNo,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[41].knowledgePoint
            }
            let isTrue=  this.CreditCard_ok(pageArr[6].m_b_cardNo ,this.VirtualInfo.accountInfo.cardNo)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[41].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[41].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[41].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[41].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          //  账单信息-有效期
          if(pageArr[6].m_b_expirationDate!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[42].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[42].regInfo,
                mcont:pageArr[6].m_b_expirationDate,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[42].knowledgePoint
            }
             let isTrue=  this.NCard_ValidDate(pageArr[6].m_b_expirationDate,this.VirtualInfo.accountInfo.cardValidity)
            if(isTrue){
                this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[42].credit
                reg_us.credit=this.regInfo.creditRuleEntityList[42].credit
                reg_us.resultCont=this.regInfo.creditRuleEntityList[42].correctShow
                reg_us.result=1
                this.infoScore.push(reg_us)
            }else{
                reg_us.credit=0
                reg_us.resultCont=this.regInfo.creditRuleEntityList[42].errorShow
                reg_us.result=0
                this.infoScore.push(reg_us)
            }
         }
         //  账单信息-持卡人姓名
          if(pageArr[6].m_b_holderName!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[43].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[43].regInfo,
                mcont:pageArr[6].m_b_holderName,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[43].knowledgePoint
            }
            let isTrue=this.YourName_ok(pageArr[6].m_b_holderName ,this.VirtualInfo.accountInfo.name)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[43].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[43].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[43].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[43].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //  账单地址-邮编
          if(pageArr[6].m_zipcode!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[44].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[44].regInfo,
                mcont:pageArr[6].m_zipcode,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[44].knowledgePoint
            }
            let isTrue=  this.pincode_ok(pageArr[6].m_zipcode,this.VirtualInfo.accountAddress.cardPostCode)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[44].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[44].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[44].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[44].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //  账单地址-省份
          if(pageArr[6].m_state!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[45].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[45].regInfo,
                mcont:pageArr[6].m_state,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[45].knowledgePoint
            }
             let isTrue= this.state_ok(pageArr[6].m_state,this.VirtualInfo.businessInfoEntity.state)
           if(isTrue && pageArr[6].m_b_flag!=0){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[45].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[45].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[45].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[45].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //  账单地址-城市
          if(pageArr[6].m_city){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[46].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[46].regInfo,
                mcont:pageArr[6].m_city,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[46].knowledgePoint
            }
            let isTrue= this.city_ok(pageArr[6].m_city,this.VirtualInfo.businessInfoEntity.city)
           if(isTrue && pageArr[6].m_b_flag!=0){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[46].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[46].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[46].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[46].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //  账单地址-区域
          if(pageArr[6].m_area){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[47].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[47].regInfo,
                mcont:pageArr[6].m_area,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[47].knowledgePoint
            }
              let ds=null
              if(this.VirtualInfo.accountAddress.cardAddressTwo){
                ds= this.VirtualInfo.accountAddress.cardAddressTwo 
              }else{
                ds= this.VirtualInfo.accountAddress.cardCity
              }
              let isTrue=  this.district1_ok(pageArr[6].m_area,ds)
           if(isTrue&& pageArr[6].m_b_flag!=0){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[47].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[47].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[47].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[47].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //  账单地址-地址行1
          if(pageArr[6].m_address1){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[48].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[48].regInfo,
                mcont:pageArr[6].m_address1,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[48].knowledgePoint
            }
             let isTrue=this.address1_ok(pageArr[6].m_address1) 
           if(isTrue && pageArr[6].m_b_flag!=0){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[48].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[48].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[48].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[48].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //  账单地址-地址行2
          if(pageArr[6].m_address2||pageArr[6].m_address1){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[49].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[49].regInfo,
                mcont:pageArr[6].m_address2||'未填写',
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[49].knowledgePoint
            }
            let isTrue=this.address2_ok(pageArr[6].m_address2) 
           if(isTrue&& pageArr[6].m_b_flag!=0){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[49].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[49].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[49].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[49].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
        
          
        }
        // reg8
        if(pageArr[7]){
           //  店铺名称
          if(pageArr[7].displayName){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[50].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[50].regInfo,
                mcont:pageArr[7].displayName,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[50].knowledgePoint
            }
            let isTrue=  this.displayname_ok(pageArr[7].displayName)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[50].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[50].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[50].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[50].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
        }
        // reg9
        if(pageArr[8]){
              //  身份证正面
         if(pageArr[8].m_idpic_front){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[51].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[51].regInfo,
                mcont:'',
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[51].knowledgePoint
            }
           if(pageArr[8].m_idpic_front=='true'){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[51].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[51].credit
              reg_us.result=1
              reg_us.mcont='上传正确'
              reg_us.resultCont=this.regInfo.creditRuleEntityList[51].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.mcont='上传错误'
              reg_us.resultCont=this.regInfo.creditRuleEntityList[51].errorShow
              this.infoScore.push(reg_us)
           }
         }
         //  身份证背面
          if(pageArr[8].m_idpic_back){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[52].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[52].regInfo,
                mcont:'',
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[52].knowledgePoint
            }
           if(pageArr[8].m_idpic_back=='true'){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[52].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[52].credit
              reg_us.result=1
              reg_us.mcont='上传正确'
              reg_us.resultCont=this.regInfo.creditRuleEntityList[52].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.mcont='上传错误'
              reg_us.resultCont=this.regInfo.creditRuleEntityList[52].errorShow
              this.infoScore.push(reg_us)
           }
         }
         //  营业执照编号
          if(pageArr[8].m_bupic){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[53].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[53].regInfo,
                mcont:'',
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[53].knowledgePoint
            }
           if(pageArr[8].m_bupic=='true'){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[53].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[53].credit
              reg_us.mcont='上传正确'
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[53].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.mcont='上传错误'
              reg_us.resultCont=this.regInfo.creditRuleEntityList[53].errorShow
              this.infoScore.push(reg_us)
           }
          }
        }
        // reg8
        if(pageArr[9]){
          // 备用手机号
           if(pageArr[9].m_phone){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[54].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[54].regInfo,
                mcont:pageArr[9].m_phone,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[54].knowledgePoint
            }
           let isTrue= this.phone_ok(pageArr[9].m_phone,this.VirtualInfo.accountInfo.backupPhone)
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[54].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[54].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[54].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.regInfo.creditRuleEntityList[54].errorShow
           }
         }
        }
         //  reg7
          //您的税收分类 
          if(sessionStorage.getItem('m_taxtype')){
            let reg_us={
                name:this.regInfo.creditRuleEntityList[55].regInfo,
                mcont:sessionStorage.getItem('m_taxtype'),
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[55].knowledgePoint
            }
               this.numScore= this.numScore+this.regInfo.creditRuleEntityList[55].credit
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[55].credit
              reg_us.mcont='业务'
              reg_us.resultCont=this.regInfo.creditRuleEntityList[55].correctShow;
              reg_us.credit=this.regInfo.creditRuleEntityList[55].credit
              reg_us.result=1
              this.infoScore.push(reg_us)
          }   
          // 你是美国人？
          if(sessionStorage.getItem('m_isUSA')){
            let reg_us={
                name:this.regInfo.creditRuleEntityList[56].regInfo,
                mcont:sessionStorage.getItem('m_isUSA'),
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[56].knowledgePoint
            }
              this.numScore= this.numScore+this.regInfo.creditRuleEntityList[56].credit
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[56].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[56].credit
              reg_us.result=1
              reg_us.mcont='否'
              reg_us.resultCont=this.regInfo.creditRuleEntityList[56].correctShow;
              this.infoScore.push(reg_us)
         }
            //  收益所有人类型=
          if(sessionStorage.getItem('m_benType')){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[57].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[57].regInfo,
                mcont:sessionStorage.getItem('m_benType'),
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[57].knowledgePoint
            }
           let isTrue=  this.benType_ok(sessionStorage.getItem('m_benType'))
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[57].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[57].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[57].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
               reg_us.resultCont=this.regInfo.creditRuleEntityList[57].errorShow
              this.infoScore.push(reg_us)
           }
         }
        // 组织名称
          if(sessionStorage.getItem('m_og_name')){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[58].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[58].regInfo,
                mcont:sessionStorage.getItem('m_og_name'),
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[58].knowledgePoint
            }
            // console.log()
           let isTrue=  this.OrganizationName_ok(sessionStorage.getItem('m_og_name'),this.VirtualInfo.businessInfoEntity.name)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[58].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[58].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[58].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[58].errorShow
              this.infoScore.push(reg_us)
           }
         }
          // 组织所在国家
          if(sessionStorage.getItem('m_og_country')){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[59].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[59].regInfo,
                mcont:sessionStorage.getItem('m_og_country'),
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[59].knowledgePoint
            }
           let isTrue= this.countrycn_ok(sessionStorage.getItem('m_og_country'))
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[59].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[59].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[59].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[59].errorShow
              this.infoScore.push(reg_us)
           }
         }
        //  无视实体名称
          if(sessionStorage.getItem('m_Disregarded_name')||sessionStorage.getItem('m_og_country')){
            let reg_us={
                name:this.regInfo.creditRuleEntityList[60].regInfo,
                mcont:sessionStorage.getItem('m_Disregarded_name') ||'没有填写',
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[60].knowledgePoint
            }
           let isTrue=  true;
           if(isTrue){
              reg_us.credit=this.regInfo.creditRuleEntityList[60].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[60].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[60].errorShow
              this.infoScore.push(reg_us)
           }
         }
          //  永久地址国家
          if(sessionStorage.getItem('m_Permanent_country')){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[61].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[61].regInfo,
                mcont:sessionStorage.getItem('m_Permanent_country'),
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[61].knowledgePoint
            }
           let isTrue=  this.countrycn_ok(sessionStorage.getItem('m_Permanent_country'))
         
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[61].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[61].credit
              reg_us.result=1
              this.infoScore.push(reg_us)
              reg_us.resultCont=this.regInfo.creditRuleEntityList[61].correctShow
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[61].errorShow
              this.infoScore.push(reg_us)
           }
         }
          // 街道和号码
          if(sessionStorage.getItem('m_tax_addr_1')){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[62].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[62].regInfo,
                mcont:sessionStorage.getItem('m_tax_addr_1'),
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[62].knowledgePoint
            }
           let isTrue=  this.address1_ok(sessionStorage.getItem('m_tax_addr_1'))
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[62].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[62].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[62].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[62].errorShow
              this.infoScore.push(reg_us)
           }
         }
          // 门牌号
          if(sessionStorage.getItem('m_tax_addr_2')|| sessionStorage.getItem('m_tax_addr_1')){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[63].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[63].regInfo,
                mcont:sessionStorage.getItem('m_tax_addr_2') ||'没有填写',
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[63].knowledgePoint
            }
             let isTrue=false;
             if(sessionStorage.getItem('m_tax_addr_2')==null){
             isTrue=true;
             }else{
                isTrue = this.address2_ok(sessionStorage.getItem('m_tax_addr_2'))
             }
           if(isTrue ||isTrue){
               this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[63].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[63].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[63].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[63].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          //  城市
          if(sessionStorage.getItem('m_tax_city')){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[64].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[64].regInfo,
                mcont:sessionStorage.getItem('m_tax_city'),
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[64].knowledgePoint
            }
           let isTrue=  this.city_ok(sessionStorage.getItem('m_tax_city'),this.VirtualInfo.businessInfoEntity.city)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[64].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[64].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[64].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[64].errorShow
              this.infoScore.push(reg_us)
           }
         }
          //  省份
          if(sessionStorage.getItem('m_tax_state')){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[65].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[65].regInfo,
                mcont:sessionStorage.getItem('m_tax_state'),
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[65].knowledgePoint
            }
           let isTrue=  this.state_ok(sessionStorage.getItem('m_tax_state'),this.VirtualInfo.businessInfoEntity.state)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[65].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[65].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[65].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[65].errorShow
              this.infoScore.push(reg_us)
           }
         }
          //  邮政编码
          if(sessionStorage.getItem('m_taxzipcode')){
             this.numScore= this.numScore+this.regInfo.creditRuleEntityList[66].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[66].regInfo,
                mcont:sessionStorage.getItem('m_taxzipcode'),
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[66].knowledgePoint
            }
           let isTrue=  this.pincode_ok(sessionStorage.getItem('m_taxzipcode') ,this.VirtualInfo.businessInfoEntity.postCode )
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[66].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[66].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[66].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[66].errorShow
              this.infoScore.push(reg_us)
           }
         }
        //  签名=
          if(sessionStorage.getItem('m_Signature')){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[67].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[67].regInfo,
                mcont:sessionStorage.getItem('m_Signature'),
                credit:null,
                result:null,
                resultCont:'',
                knowledgePoint:this.regInfo.creditRuleEntityList[67].knowledgePoint
            }
           let isTrue=  this.YourName_ok(sessionStorage.getItem('m_Signature'),this.VirtualInfo.accountInfo.name)
           if(isTrue){
             this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[67].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[67].credit
              reg_us.result=1
              reg_us.resultCont=this.regInfo.creditRuleEntityList[67].correctShow
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.result=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[67].errorShow
              this.infoScore.push(reg_us)
           }
         }
         
         //  选择收款账户所在国家
         if(sessionStorage.getItem('seCountry')!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[68].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[68].regInfo,
                mcont:sessionStorage.seCountry,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[68].knowledgePoint
            }
           if(sessionStorage.seCountry=='US'||sessionStorage.seCountry=='美国'){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[68].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[68].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[68].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[68].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         //  选择收款账户所在国家
         if(sessionStorage.getItem('ckCountry')!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[69].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[69].regInfo,
                mcont:sessionStorage.ckCountry,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[69].knowledgePoint
            }
           if(sessionStorage.ckCountry=='US'||sessionStorage.ckCountry=='美国'){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[69].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[69].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[69].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[69].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
         
          //  持卡人姓名
         if(sessionStorage.ckAccountHolderName!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[70].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[70].regInfo,
                mcont:sessionStorage.ckAccountHolderName,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[70].knowledgePoint
            }
             let isTrue= this.YourName_ok(sessionStorage.ckAccountHolderName ,this.VirtualInfo.accountInfo.name )
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[70].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[70].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[70].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[70].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
        //  填入收款账户9位数的银行识别代码
         if(sessionStorage.ckRoutingNumber!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[71].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[71].regInfo,
                mcont:sessionStorage.ckRoutingNumber,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[71].knowledgePoint
            }
             let isTrue= sessionStorage.ckRoutingNumber==this.VirtualInfo.accountInfo.routingNumber
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[71].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[71].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[71].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[71].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
          //  银行账户
         if(sessionStorage.ckAccountNumber!=null){
            this.numScore= this.numScore+this.regInfo.creditRuleEntityList[72].credit
            let reg_us={
                name:this.regInfo.creditRuleEntityList[72].regInfo,
                mcont:sessionStorage.ckAccountNumber,
                credit:null,
                resultCont:'',
                result:null,
                knowledgePoint:this.regInfo.creditRuleEntityList[72].knowledgePoint
            }
             let isTrue= sessionStorage.ckAccountNumber==this.VirtualInfo.accountInfo.accountNumber
           if(isTrue){
              this.thisScore= this.thisScore+this.regInfo.creditRuleEntityList[72].credit
              reg_us.credit=this.regInfo.creditRuleEntityList[72].credit
              reg_us.resultCont=this.regInfo.creditRuleEntityList[72].correctShow
              reg_us.result=1
              this.infoScore.push(reg_us)
           }else{
              reg_us.credit=0
              reg_us.resultCont=this.regInfo.creditRuleEntityList[72].errorShow
              reg_us.result=0
              this.infoScore.push(reg_us)
           }
         }
        }

      }
      ,
      getVideo(){
        if(this.VideoNum){
          this.$axios
          .get(this.interfaceJson.serverAddress+"/api/site/videoHelp?site=US_NEW&step="+this.VideoNum)
          .then(res => {
          let data=res.data;
          if(data.code==0){
            window.open(data.data,'foo','noopener=yes,noreferrer=yes')
          }
          });
        }
      },
     cancalChild(e) {
       if(e=='score'){
         if(this.infoScore){
           this.isScore=true;
           this.getScoreList()
           this.isSelectPop=false;
         }
       }
       if(e==0){
        this.AccountInfo=true;
        this.isIds=false;
         this.businessLicense=false;
       }else if(e==1){  
         this.isIds=true;
         this.AccountInfo=false;
          this.businessLicense=false;

       }else if(e==2){
         this.businessLicense=true;
         this.AccountInfo=false;
         this.isIds=false;
       }
       else if(e=='pingyin'){
         this.isPy=!this.isPy
         this.zwCont='';
         this.pingyinCont='';
       }
       else if(e=='leasing'){
         this.isLeasing=!this.isLeasing
       }
       else if(e=='video'){
         this.isVideo=!this.isVideo
         this.getVideo()
       }
       else if(e=='chis'){
         if(this.chis=='0') {
              this.iframeWin.postMessage({
                chis:'1'
                }, '*') 
                this.chis='1'
                this.isChisShow=true;
         }else{
              this.iframeWin.postMessage({
              chis:'0'
              }, '*') 
              this.chis='0'
              this.isChisShow=false;
         } 
       }else if(e=='help'){
          if(this.help=='0') {
              this.iframeWin.postMessage({
                help:'1'
                }, '*') 
                this.help='1'
                this.isHelpShow=true;
         }else{
              this.iframeWin.postMessage({
              help:'0'
              }, '*') 
              this.help='0'
              this.isHelpShow=false;
         } 
       }
    },
  },
  components: {
    SiteHead,
    CommonPop
  }
};
</script>
<style lang="scss" scoped>

.colsPop{
  position: fixed;
  width:400px;
  height:645px;
  top:85px;
  z-index: 99999;
  background:#ffffff;
  box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  border-radius:2px;
  box-sizing: border-box;
  padding: 0 24px 0 25px;
  left: 24px;
}

.colsCont{
  position: relative;
  .pinyin{
    position: absolute;
    left: 0px;
    bottom: -25px;
    border:1px solid #F3CD70;
    font-size: 12px;
    height: 30px;
    border-radius: 21px;
    line-height: 30px;
    text-align: center;
    width: 90px;
    cursor: pointer;
  }
  .lv{
    background-color: #F3CD70;
  }
}
.colsCont .close{
  position: absolute;
  top: 16px;
  right: 0px;
  cursor: pointer;
  color: #232F3E;
}
.colsCont .close img{
  width: 16px;
  height: 16px;
}
.colsPop .head{
  border-bottom:1px solid #e8e8e8;
  height: 70px;
 
}
.colsPop .head .uname{
  font-size:18px;
  line-height: 25px;
  padding-top:15px;

}
.colsPop .head .de{
  padding-top:10px;
  font-size: 12px;
  color: #FF9A00;
}
.colsPop .cont{
  padding-bottom: 14px;
  border-bottom: 1px dashed #e8e8e8;
}
.colsPop .cont:last-of-type{
   border-bottom: 0;
}
.colsPop .cont .name{
  font-size:14px;
  line-height: 25px;
  padding-top:5px;
  padding-bottom: 10px;
  position: relative;
}
.colsPop .cont .dv{
  padding-bottom: 8px;
  display: flex;
}
.colsPop .cont .dName{
  display: flex;
  justify-content: space-between;
      width: 112px;
  span{
    font-size: 12px;
    color: #57616C;
  }
}
.colsPop .cont .dv .span{
  color: #000000;
  max-width: 240px;
  line-height: 18px;
  margin-top: -3px;
  word-wrap:break-word
}
.colsPop .cont img{
  width:352px;
}
.colsPop .cont .btn{
  width:80px;
  height:30px;
  font-size:12px;
  background:#F3CD70;
  opacity:1;
  border-radius:21px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 4px;
  right: 183px;
}
.pyPop{
   height: 188px;
   left: auto;
   right: 0px;
   .close{
     top: 11px;
   }
   .head{
     height: 40px !important;
     line-height: 40px;
     .uname{
        padding-top: 0;
        font-size: 14px;
        line-height: 40px !important;
     }
   }
   .input_wrap{
     padding-top: 21px;
     .ipt{
       padding-bottom: 10px;
       display: flex;
       label{
         font-size:14px;
         margin-left: 5px;
         width: 42px;
        height:30px;
        line-height: 30px;
       }
       input{
         width:283px;
          height:30px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(232,232,232,1);
          opacity:1;
          border-radius:4px;
          outline: none;
          box-sizing: border-box;
          padding-left: 10px;
       }
     }
   }
   .iBtn{
      width:68px;
      height:20px;
      background:rgba(243,205,112,1);
      opacity:1;
      border-radius:4px;
      text-align: center;
      position: absolute;
      font-size: 12px;
      line-height: 20px;
      right: 0px;
      bottom: -37px;
      cursor: pointer;
   }
}
.view{
  height:calc(100vh - 80px) ;
  margin: 0 auto;
}
.view  iframe{
  height:100%;
  width: 100%;
}
.Home{
  background-color: #FFFFFF;
}
.content{
  // max-width: 1380px;
  // padding-top:10px ;
  margin: 0 auto;
  box-sizing: border-box;
}
.siteWrap {
  display: flex;
}
.siteWrap .siteUl{
  display: flex;
  flex-wrap:wrap ;
}
.siteWrap .siteUl .siteLi{
  margin-right: 20px;
  margin-bottom: 20px;
}
.siteWrap .siteUl .siteLi:nth-child(5n-0){
  margin-right: 0px;
}
.siteWrap .siteUl .siteLi .icon{
  background-color: #232F3E;
  height: 128px;
}
.siteWrap .siteUl .siteLi .icon img{
  width: 96px;
  height: 96px;
  padding: 26px 82px 0 82px;
}
.siteWrap .siteUl .siteLi .name{
  color: #FFFFFF;
  background-color: #2F3A48;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
// 评分弹窗
.pop_bg{
	width: 100%;
    left: 0px;
    top: 0px;
    height: 100%;
    position: fixed;
/*    user-select: none; */
    z-index: 99;
	background-color: #000;
    opacity: .5;
}
.scorePop{
  	position: fixed;
    left: 50%;
    top: 50%;
    z-index: 999;
    background-color: #fff;
    transform: translate(-50%, -50%);
    width: 1180px;
    height:500px;
    box-sizing: border-box;
    padding:0 23px 0 23px;
    .head{
      height: 85px;
      display: flex;
      position: relative;
      .el{
        display: flex;
        padding-top: 19px;
        .li{
          width: 77px;
          height: 77px;
          border:1px solid #D6D6D6;
          background-color: #fff;
          border-radius:50%;
          box-sizing: border-box;
          .num{
            width:40px;
            height:30px;
            font-size:22px;
            font-family:PingFang SC;
            font-weight:bold;
            line-height:30px;
            color: #000000;
            text-align: center;
            margin: 12px auto 0;
            border-bottom: 1px solid #D6D6D6;
          }
          .nx{
            font-size:12px;
            line-height:17px;
            color: #232F3E;
            text-align: center;
            line-height: 17px;
            margin-top: 6px;
          }
        }
        .avt{
          margin-right: 17px;
          background-color: #F3CD70;
          border:1px solid #F3CD70;
          .num{
            border-bottom: 1px solid #000000;
          }
        }
      }
      .ps{
        width:444px;
        height:17px;
        font-size:12px;
        font-weight:400;
        line-height:17px;
        color:#FF0000;
        margin-left: 17px;
        margin-top: 68px;
      }
      .btnScore{
          position: absolute;
          right: 24px;
          top:46px;
          width:110px;
          height:32px;
          background:#F3CD70;
          line-height: 32px;
          border-radius:4px;
          color: #232F3E;
          font-size:14px;
          text-align: center;
          cursor: pointer;
      }
      .close{
        position: absolute;
        top: 10px;
        right:5px;
        cursor: pointer;
        img{
          width: 16px;
          height: 16px;
        }
      }
    }
    .cont{
      margin-top: 10px;
      max-height: 358px;
      overflow-y: scroll;
      .titUl{
        display: flex;
        .li{
            flex: 1;
            border:1px solid #E1E1E2;
            padding-left: 12px;
            height: 50px;
            line-height: 15px;
            align-items: center;
            color: #000000;
            display: flex;
            font-size:14px;
            background-color: #EBEBEB;
            border-right:0;
        }
        .li:last-of-type{
          border-right:1px solid #E1E1E2;
        }
        .fx4{
            flex: 4; 
        }
      }
      .conList{

        .titUl{
          .li{
            font-size: 12px;
            background-color: #F5F5F5;
            display: flex;
            align-items: center;
          }
          .dP{
           
            img{
              width:20px;
              margin-right: 10px;
            }
          }  
        }
        .titUl:nth-child(odd){
           .li{
              border-top: 0;
             border-bottom: 0;
             background-color: #fff;
           }

        }
        .titUl:last-of-type{
           border-bottom:1px solid #E1E1E2;
            .li{
              border-bottom: 0;
            }
        }
        .avt{
            .li{
              color: #FF0000;
           }
        } 
      }
      
    }
}
.selectPop{
  position: fixed;
	left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-shadow:0px 0px 20px rgba(0,0,0,0.16);
  width:400px;
  height:200px;
  border-radius:2px;
  box-sizing: border-box;
  padding: 0 25px;
  .title{
    border-bottom:1px solid #e8e8e8;
    height: 81px;
    line-height: 81px;
    font-size:18px;
    color: #000;
    text-align: center;
    position: relative;
    .close{
      position: absolute;
      top: -13px;
      right: 0px;
      cursor: pointer;
      img{
        width: 16px;
        height: 16px;
      }
    }
  }
  .btn{
    width:120px;
    height:40px;
     text-align: center;
    background:rgba(243,205,112,1);
    opacity:1;
    border-radius:21px;
    font-size:14px;
    color:rgba(35,47,62,1);
    line-height: 40px;
    margin: 47px auto 0;
    cursor: pointer;
  }
}
.tipsPop{
	width: 400px;
	height: 235px;
	box-shadow:0px 0px 20px rgba(0,0,0,0.16);
	border-radius:2px;
	position: fixed;
	left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  padding: 0  32px 0 34px;
  .head{
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-bottom:1px solid #E8E8E8;
    color: #000000;
    position: relative;
     .icon{
        position: absolute;
        right: -10px;
        top: 0px;
        cursor: pointer;
        img{
          width: 10px;
          height: 10px;
        }
      } 
  }
  .co{
    width:322px;
    line-height:20px;
    font-size:12px;
    margin-top: 12px;
    text-align: center;
  }
  .cont{
    text-align: center;
    line-height:20px;
    font-size:12px;
    margin: 0 auto;
    width:300px;
    padding-top: 25px;
  }
  .btnWrap{
    text-align: center;
    margin-top:34px;
    .btn{
      width:110px;
      height:32px;
      border-radius: 4px;
      background-color: #F3CD70;
      color: #232F3E;
      font-size:12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      box-sizing: border-box;
      vertical-align: middle;
    }
    .btnN{
       width:110px;
      height:32px;
      border-radius: 4px;
      background-color: #FFFFFF;
      border:1px solid rgba(243,205,112,1);
      box-sizing: border-box;
      color: #57616C;
      font-size:12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      margin-left: 10px;
      vertical-align: middle;
    }
  }
}
</style>
<style >
  .Home .el-carousel__container  {
    height: 580px;
  }
</style>